// 酒店七大类图标（icon / icon1 / icon2）统一用 2026-09 改版的线框图标，见 src/assets/img/category/
// （和 src/icons/svg/ 的同名文件是同一份，改图标两边一起改）。变量名沿用旧图片的名字，指向的已是新图标
import Group1 from "@/assets/img/category/sun.svg";
import Group2 from "@/assets/img/category/clean.svg";
import Group3 from "@/assets/img/category/bed.svg";
import Group4 from "@/assets/img/category/location.svg";
import Group5 from "@/assets/img/category/food.svg";
import Group6 from "@/assets/img/category/money.svg";
import Group7 from "@/assets/img/category/services.svg";
import Group1_1 from "@/assets/img/category/location.svg";
import Group2_1 from "@/assets/img/category/clean.svg";
import Group3_1 from "@/assets/img/category/bed.svg";
import Group4_1 from "@/assets/img/category/sun.svg";
import Group5_1 from "@/assets/img/category/services.svg";
import Group6_1 from "@/assets/img/category/food.svg";
import Group7_1 from "@/assets/img/category/money.svg";
import Group8_1 from "@/assets/img/Group8_1.png"
import icon_FB from "@/assets/img/category/food.svg";
import icon_Amenities from "@/assets/img/category/sun.svg";
import icon_Cleanness from "@/assets/img/category/clean.svg";
import icon_Location from "@/assets/img/category/location.svg";
import icon_Room from "@/assets/img/category/bed.svg";
import icon_Service from "@/assets/img/category/services.svg";
import icon_Value from "@/assets/img/category/money.svg";
import icon_Brand1 from "@/assets/img/icon_Brand1.png";
import img_english from "@/assets/img/img_english.png"
import img_chinese from "@/assets/img/img_chinese.png"
import img_German from "@/assets/img/img_German.png"
import img_Italian from "@/assets/img/img_Italian.png"
import icon_Brand from "@/assets/img/icon_Brand.png";
import global from '@/assets/img/global.png'
import APAC from '@/assets/img/APAC.png'
import CHINA from '@/assets/img/CHINA.png'
import EMEA from '@/assets/img/EMEA.png'
import N_A from '@/assets/img/N_A.png'
import MIDDLE_EAST from '@/assets/img/MIDDLE_EAST.png'
import AFRICA from '@/assets/img/AFRICA.png'
import SOUTH_AMERICA from '@/assets/img/SOUTH_AMERICA.png'
// 餐厅六大类同样换成 2026-09 的线框图标（src/assets/img/category/icon_*.svg，和 src/icons/svg/ 同名文件是同一份）
import Food_Quality from '@/assets/img/category/icon_Food_Quality.svg'
import Beverage_Quality from '@/assets/img/category/icon_Beverage_Quality.svg'
import Service_Quality from '@/assets/img/category/icon_Service_Quality.svg'
import Ambience from '@/assets/img/category/icon_Ambience.svg'
import Value_For_Money from '@/assets/img/category/icon_Value_For_Money.svg'
import Cleanliness from '@/assets/img/category/icon_Cleanliness.svg'
export default {
    // 模块加载状态（components/common/ModuleLoadState.vue）
    ModuleLoad: {
        loading: 'Wird geladen…',
        slow: 'Dauert länger als üblich',
        failed: 'Konnte nicht geladen werden',
        retry: 'Erneut versuchen',
    },
    countryArr:[
        {
            name:'中文',
            value:'zh',
            icon:img_chinese
        },
        {
            name:'English',
            value:'en',
            icon:img_english
        },
        // {
        //     name:'Italienisch',
        //     value:'it',
        //     icon:img_Italian
        // },
        {
            name:'Deutsch',
            value:'de',
            icon:img_German
        },
    ],
    message: {
        coming_soon:'Bald verfügbar',
        language: 'Deutsch',
        gmb:'Ein Produkt von Where to know Insights GmbH',
        Settings_saved:'Einstellungen gespeichert',
        CurrentPassword:"Aktuelles Passwort darf nicht leer sein",
        CurrentPassword1:"Passwortbestätigung stimmt nicht mit dem Passwort überein",
        CurrentPassword2:"Passwort geändert",
        sidebar:"Erfolgreich abgemeldet",
        competitors:'Bitte wählen Sie zuerst ein Hotel aus',
        competitors1:'Serverfehler. Bitte versuchen Sie es später erneut',
        DateTimePickerHome: 'Das Enddatum darf das aktuelle Datum nicht überschreiten',
        DateTimePickerHome1: 'Hotels konnten nicht geladen werden. Bitte versuchen Sie es erneut',
        DateTimePickerHome2: 'Wählen Sie mindestens eine Plattform aus',
        platformOverview: 'Datei erfolgreich hochgeladen',
        platformOverview1: 'Dateigröße darf 5MB nicht überschreiten',
        platformOverview2: 'Bitte laden Sie zuerst eine Datei hoch',
        login:'Bitte geben Sie Ihren Benutzernamen und Ihr Passwort ein',
        login1:"Erfolgreich eingeloggt",
        login2:"Login fehlgeschlagen. Der Benutzername oder das Passwort ist falsch",
        login3:"Anfrage zum Einloggen fehlgeschlagen. Bitte versuchen Sie es später erneut",
        Reviews:"Derzeit gibt es keine Kommentare. Bitte filtern Sie erneut",
        Reviews1:"Ihre Anmeldung ist abgelaufen. Jetzt einloggen...",
        Reviews2:"Serverfehler. Bitte versuchen Sie es später erneut",
        Reviews3:"Netzwerkfehler. Bitte versuchen Sie es später erneut",
        Exporting:"Wird exportiert, bitte warten...",
        Download_ready:"Download bereit",
        Export_failed:"Export fehlgeschlagen",
        Export_no_evidence:"Ohne Bewertungsbelege exportiert — kein Zugriff auf Bewertungen",
        AI:"Der Originalinhalt darf nicht leer sein und kann nicht übersetzt werden",
        AI1:"Die Übersetzungschnittstelle gibt eine Ausnahme zurück. Bitte versuchen Sie es erneut",
        AI2:"Übersetzung fehlgeschlagen. Bitte überprüfen Sie Ihr Netzwerk oder versuchen Sie es erneut",
        AI3:"In die Zwischenablage kopiert",
        AI4:"Kopieren fehlgeschlagen. Bitte versuchen Sie es erneut",
        AI5:"Erfolgreich gesendet",
        AI6:"Kein übersetzter Inhalt",
        AI7:"Zielsprache konnte nicht abgerufen werden. Bitte versuchen Sie es erneut",
        AI8:"Übersetzung fehlgeschlagen. Bitte versuchen Sie es erneut",
        AI9:"Bitte schreiben Sie den Originalinhalt, Herr",
        AI10:"Verarbeitung läuft. Bitte operieren Sie später",
        AI11:"Bitte wählen Sie zuerst die Übersetzungssprache aus",
        AI12:"Neuer KI-Inhalt konnte nicht abgerufen werden",
        FilterContainer:"Die Filtereinstellungen wurden angewendet",
        FilterContainer1:"Der Anwendungsvorgang wurde abgebrochen",
        onlyTrans:'Bitte wählen Sie die Sprache aus',
        ReplyResponeRate:'Mindestens eine Plattform muss ausgewählt werden',
        LikeSuccess:'Diese Antwort wurde gespeichert. Bitte besuchen Sie später den Abschnitt „Antwortvorlagen“, um sie anzuzeigen.',
        LikeTooltip:'Bitte klicken Sie zunächst auf "Generieren"',
        noLikeSuccess:'Löschen der Favorisierung erfolgreich',
        requestFailed:'Anfrage fehlgeschlagen. Bitte erneut versuchen.',
        noLikeTooltip:'Aufhebung der Sammlung',
        Saved_successfully:'Erfolgreich gespeichert',
        Notes_saved:'Notizen gespeichert',
        Removed_from_Reply_Library:'Aus der Antwortbibliothek entfernt',
        Couldn_remove_from_Reply_Library:"Kann nicht aus der Antwortbibliothek entfernt werden",
    },
    sidebar: {
        replayGuide: 'Anleitung erneut ansehen',
        language: 'Sprache',
        // 侧边栏 New 胶囊、品牌模式里拼出来的菜单名（集团名 / 品牌名是数据，只翻译固定部分）
        newBadge:'Neu',
        groupOverview:'{group} Übersicht',
        thailandLuxuryOverview:'Übersicht Luxushotels Thailand',
        brandDetails:'{brand} – Details',
    },
    sidebarGuide: {
        skip: 'Überspringen',
        prev: 'Zurück',
        next: 'Weiter',
        finish: 'Fertig',
        steps: {
            hotelSelector: { title: 'Hotel wechseln', desc: 'Klicken Sie auf den Hotelnamen, um zwischen all Ihren verwalteten Häusern zu wechseln.' },
            moduleSwitch: { title: 'Hotel-/Restaurant-Modus', desc: 'Wechseln Sie zwischen Hotel- und Restaurant-Ansicht — jede hat ihr eigenes Dashboard und Menü.' },
            aiChat: { desc: "Stellen Sie Fragen in normaler Sprache und erhalten Sie sofort datengestützte Antworten zur Leistung Ihres Hotels." },
            overview: { desc: "Das Dashboard Ihres Hotels — Plattformbewertungen, Antwortrate, neueste Bewertungen und Themen, die Aufmerksamkeit brauchen, auf einen Blick." },
            reviews: { desc: 'Lesen und beantworten Sie jede Gästebewertung, verfolgen Sie markierte Fälle und verwalten Sie Ihre Antwortvorlagen.' },
            competition: { desc: 'Vergleichen Sie sich mit Mitbewerbern in der Nähe anhand von OTA-Bewertungen und Rezensionen.' },
            insights: { desc: 'Tiefere Berichte und Marken-Übersichten, um Trends über all Ihre Häuser hinweg zu erkennen.' },
            surveys: { desc: 'Sammeln Sie Gästefeedback während und nach dem Aufenthalt mit individuellen Umfragen.' },
            restaurantSelector: { title: 'Restaurant wechseln', desc: 'Klicken Sie auf den Namen Ihres Restaurants, um zwischen allen Ihren Outlets zu wechseln.' },
            restaurantAiChat: { desc: 'Stellen Sie Fragen in normaler Sprache und erhalten Sie sofort datenbasierte Antworten zur Leistung Ihres Restaurants.' },
            restaurantOverview: { desc: 'Das Dashboard Ihres Restaurants – Plattformbewertungen, Antwortrate, neueste Bewertungen, Punktzahlen nach Bereich sowie Erwähnungen von Mitarbeitenden und Gerichten.' },
            restaurantReviews: { desc: 'Alle Gästebewertungen lesen und beantworten, markierte Fälle verfolgen und Antworteinstellungen und Vorlagen verwalten.' },
            restaurantCompetition: { desc: 'Vergleichen Sie sich bei Plattformbewertungen und Rezensionen mit Restaurants in der Nähe.' },
            restaurantInsights: { desc: 'Monatsberichte und längerfristige Rückblicke auf die Leistung Ihres Restaurants.' },
            generals: { desc: 'Verwalten Sie Kontoeinstellungen und finden Sie Antworten im Hilfe-Center.' },
        },
    },
    // 新手导览名称（Help Center「Replay guide」列表，见 utils/guideTours.js）
    guideTours: {
        sidebar: 'Seitenleisten-Navigation',
        home: 'Hotelübersicht',
        reviews: 'Bewertungen',
        restaurantReviews: 'F&B-Bewertungen',
        restaurantSidebar: 'Seitenleisten-Navigation',
        restaurantHome: 'Restaurantübersicht',
        skip: 'Überspringen',
        prev: 'Zurück',
        next: 'Weiter',
        finish: 'Fertig',
    },
    restaurantHomeGuide: {
        steps: {
            platforms: { title: 'Plattformübersicht', desc: 'Bewertung, Antwortrate und durchschnittliche Antwortzeit jeder Plattform – und ungefähr wie viele Höchstbewertungen bis zu Ihrem Zielwert nötig sind.' },
            activity: { title: 'Aktuelle Aktivität & Top-Listen', desc: '„{recent}“ zeigt Bewertungen der letzten 72 Stunden – wechseln Sie den Typ, um zu sehen, was Gäste gelobt oder bemängelt haben. „{topLists}“ listet die meistgenannten Stärken und Probleme des letzten Monats.' },
            filters: { title: 'Plattformen & Zeitraum', desc: 'Wählen Sie Plattformen und einen Zeitraum – alle Punktzahlen und Listen darunter werden entsprechend aktualisiert.' },
            scores: { title: 'Punktzahlen', desc: 'Ihre Gesamtpunktzahl und jeder Bereich – Essen, Getränke, Service und mehr. Fahren Sie über das Augensymbol für positive / neutrale / negative Anzahlen, klicken Sie für die Unterkategorien.' },
            attention: { title: '{areasWarning}', desc: 'Unterkategorien, die Ihre Punktzahl nach unten ziehen. Läuft alles gut, bleibt dieser Bereich leer.' },
            competitors: { title: 'Wettbewerber', desc: 'Wie Ihre Gesamtpunktzahl im Vergleich zu den beobachteten Wettbewerbern abschneidet.' },
            mentions: { title: 'Erwähnungen von Team & Speisen', desc: 'Die Mitarbeitenden, Gerichte und Getränke, die Gäste am häufigsten erwähnen, und wie positiv diese Erwähnungen sind. Klicken Sie auf eine Zeile, um die Bewertungen zu lesen.' },
        },
    },
    reviewsGuide: {
        steps: {
            period: { title: 'Zeitraum', desc: 'Wählen Sie einen Zeitraum oder genaue Daten – Plattformkarten und Bewertungsliste darunter werden gemeinsam aktualisiert.' },
            tools: { title: 'Suche, Filter & Export', desc: 'Bewertungstexte durchsuchen, Listenansicht wechseln, nach Punktzahl, Bewertungstyp, Stimmung oder Kategorie filtern und die angezeigten Bewertungen exportieren.' },
            platforms: { title: 'Plattformen', desc: 'Jede Karte zeigt die durchschnittliche Punktzahl und die Anzahl der Bewertungen der Plattform in diesem Zeitraum. Klicken Sie auf eine Karte, um die Bewertungen dieser Plattform ein- oder auszublenden.' },
            card: { title: 'Bewertungsdetails', desc: 'Jede Karte ist eine Bewertung. Markierungen wie „{mismatch}“ heben Bewertungen hervor, die einen genaueren Blick lohnen, „{goTo}“ öffnet das Original. Mit „{expand}“ sehen Sie die ganze Analyse – öffnen wir diese hier.' },
            score: { title: 'WQI-Score', desc: 'Die KI-Bewertung dessen, was der Gast geschrieben hat, von 1 bis 10 (5-Punkte-Plattformen werden umgerechnet). Fahren Sie mit der Maus darüber, um die Farbskala zu sehen.' },
            translate: { title: 'Übersetzung', desc: 'Wählen Sie eine Sprache, um die Bewertung zu übersetzen, und wechseln Sie hier zwischen Übersetzung und Original.' },
            guestTags: { title: 'Gast-Tags', desc: '„{guestTags}“ sind die Angaben, die der Gast beim Verfassen auf der Plattform gewählt hat – Bewertungen für Essen, Service und Atmosphäre, Gruppengröße, Lautstärke und mehr. Unter Filter können Sie Bewertungen danach filtern.' },
            analysis: { title: 'KI-Analyse', desc: '„{dimensions}“ zeigt, welche Themen die Bewertung anspricht, welchen Anteil jedes hat und wie es abschneidet. „{summary}“ fasst die Bewertung in einem Satz zusammen.' },
            note: { title: 'Notizen', desc: 'Hinterlassen Sie eine interne Notiz für Ihr Team. Sie bleibt in WTK und wird nie auf der Plattform veröffentlicht.' },
            actions: { title: 'Weiterleiten & Antworten', desc: '„{forward}“ schickt die Bewertung per E-Mail an Kollegen. „{reply}“ erstellt einen KI-Antwortentwurf auf Basis Ihrer „{replySetting}“ – bearbeiten und auf die Plattform kopieren.' },
            actionsGoogle: { title: 'Weiterleiten & Antworten', desc: '„{forward}“ schickt die Bewertung per E-Mail an Kollegen. „{reply}“ erstellt einen KI-Antwortentwurf auf Basis Ihrer „{replySetting}“ – bearbeiten, kopieren oder direkt auf Google veröffentlichen.' },
            actionsReplied: { title: 'Weiterleiten & Antworten', desc: '„{forward}“ schickt die Bewertung per E-Mail an Kollegen. Diese Bewertung wurde bereits beantwortet, daher zeigt die Schaltfläche „{replied}“; bei unbeantworteten Bewertungen erstellt „{reply}“ einen KI-Antwortentwurf auf Basis Ihrer „{replySetting}“ zum Bearbeiten und Kopieren auf die Plattform.' },
        },
    },
    homeGuide: {
        skip: 'Überspringen',
        prev: 'Zurück',
        next: 'Weiter',
        finish: 'Fertig',
        steps: {
            overview: { title: 'Dashboard-Übersicht', desc: 'Hier sehen Sie die Gesamtleistung Ihrer Plattform — Antwortrate, Aktivität der letzten 24 Stunden sowie Highlights und Probleme der letzten Woche — auf einen Blick.' },
            dateRange: { title: 'Zeitraum', desc: 'Wechseln Sie hier den Zeitraum und die Bewertungsplattformen — alle Diagramme und Kennzahlen unten aktualisieren sich automatisch entsprechend Ihrer Auswahl.' },
            needsAttention: { title: 'Punkte, die Aufmerksamkeit brauchen', desc: 'Listet die Unterkategorien, die am meisten Beachtung verdienen, nach Anzahl der Bewertungen, Score und Auswirkung — klicken Sie auf eine Zeile für Details.' },
            highlights: { title: 'Stärken & Verbesserungspunkte', desc: 'Wechseln Sie zwischen Stärken und Problemen, um die meistgenannten positiven Stichworte der letzten Woche und die Verbesserungspunkte zu sehen.' },
            evidence: { title: 'Original-Bewertungen ansehen', desc: 'Klicken Sie auf eine der Kategorie-Karten unten (Lage, Sauberkeit usw.), um die Original-Gästebewertungen hinter diesem Wert zu öffnen.' },
        },
    },
    // 404 页（views/error/404.vue）
    NotFound:{
        desc:"Die angeforderte Seite existiert leider nicht",
        backHome:"Zur Startseite",
    },
    menu:{
        // Quality Standards 页：侧栏用短名，页面头部用全称。
        'Quality Standards': 'Qualitätsstandards',
        // 新版 WTK Luxury Standards 的侧栏名（只给 featureGates.js 的 LUXURY_STANDARDS_HOTELS）。页面本身只有英文
        'Luxury Standards': 'Luxury Standards',
        // 半年报两个侧栏入口（RouterMenu.vue）。de / it 暂用英文
        'Market Signals': 'Market Signals',
        'Half-Year Review': 'Half-Year Review',
        // 酒店那份半年报改名 Period Review（周期长度会变，名字里不写时长）；F&B 仍用上面那条
        'Period Review': 'Period Review',
        QualityStandards_Title: 'Gästefeedback & Qualitätsstandards',
        QualityStandards_EmptyTitle: 'Keine Standarddaten für dieses Hotel',
        QualityStandards_EmptyDesc: 'Dieses Hotel ist im aktuellen LQA-/Forbes-/MICHELIN-Datensatz nicht enthalten. Wählen Sie im Hotelwechsler ein enthaltenes Hotel aus.',
        'Hotel Overview': 'Hotel Übersicht',
        'Hotel Dashboard': 'Hotel-Dashboard',
        'Reports': 'Berichte',
        'PortiolioBriefing': 'Portfolio Briefing',
        'BrandOverview':'Markenübersicht',
        BrandOverview2:'Portfolio-Analyse',
        BrandOverviewList:'Markenübersicht',
        'Restaurant Dashboard': 'Restaurant Dashboard',
        'Reviews & Reply': 'Bewertungen & Antworten',
        'Reviews': 'Bewertungen',
        'ReplyLike': 'Antwortvorlage',
        'Replies': 'Antworten',
        'Reply Setting': 'Antworteinstellung',
        'Competitors' : 'Wettbewerber',
        'Settings' : 'Einstellungen',
        'Restaurant' : 'Restaurant',
        'Help Center (FAQ)':'Hilfezentrum (FAQ)',
        'AI Chat':'Intelligenz',

        'Dashboards': 'Dashboard',
        'dashboard': 'Dashboard',
        'Restaurant Overview': 'Restaurant Dashboard',
        'Reviews & Replies': 'Fallmanagement',
        'Case Management': 'Fallmanagement',
        'Hotel': 'Hotel',
        // Nur für den Hotel/F&B/Brand-Umschalter in der Sidebar — bewusst
        // getrennt vom obigen 'Restaurant', das andere Menülabels weiter nutzen.
        'F&B': 'F&B',
        'Brand': 'Marke',
        'Hotel Reviews': 'Hotel Bewertungen',
        'Restaurant Reviews': 'Restaurant Bewertungen',
        'Hotel Reply Setting': 'Hotel Antworteinstellung',
        'Hotel Reply Template': 'Hotel Antwortvorlage',
        'Food & Beverage': 'Restaurant',
        'F&B Reviews': 'Restaurant Bewertung',
        'F&B Reply Setting': 'Restaurant Antworteinstellung',
        'F&B Reply Template': 'Restaurant Ergebnisvorlage',
        'Competition': 'Wettbewerber',
        'Hotel Competitors': 'Hotel Wettbewerber',
        'Restaurant Competitors': 'Restaurant Wettbewerber',
        'Competitors_OTA_Reports': 'Marktüberblick',
        'Competitors_Benchmarks': 'Wettbewerbs-Benchmark',
        'Insights':'Analyse',
        'Brand Overview':'Markenübersicht',
        'Generals':'Allgemein',
        'Setting':'Einstellungen',
        'Survey':'Untersuchung',
        'Surveys':'Umfragen',
        'During Stay':'Während des Aufenthalts',
        'Post Stay':'Nach dem Aufenthalt',
        'Survey Detail':'Umfragedetails',
        'Needs Attention':'Handlungsbedarf',
        'Reply Library':'Antwortbibliothek',
        'Staff Management':'Mitarbeiterverwaltung',
        'Connections':'Verbindungen',
        // 品牌模式侧栏的 Active Signal Details 入口
        ActiveSignalDetails:'Aktive Signale – Details',
    },
    DateMonth:{
        Jan: 'Januar',
        Feb: 'Februar',
        Mar: 'März',
        Apr: 'April',
        May: 'Mai',
        Jun: 'Juni',
        Jul: 'Juli',
        Aug: 'August',
        Sep: 'September',
        Oct: 'Oktober',
        Nov: 'November',
        Dec: 'Dezember'
    },
    Filter:'Filtern',
    Date:'Datum',
    SML_ReviewsShowBox:{
        emptyState:{
            title:'Keine passenden Bewertungen',
            description:'Für die aktuellen Filter wurden keine Bewertungen gefunden. Passen Sie die Filter an oder setzen Sie sie zurück.',
            resetBtn:'Filter zurücksetzen',
        },
    },
    inputPlaceholder:"Eingang",
    selectPlaceholder:"Auswahl",
    Frequency:"Frequency",
    Example:'Beispiel：',
    Sort:'Sortieren nach',
    Score:'Bewertung',
    WTK_Score:'WQI',
    Time:'Zeit',
    Email:'E-Mail-Adresse',
    Proportion:'Verhältnis',
    No_of_reviews:'Anzahl der Bewertungen',
    No_data:'No data',
    NA:'N/A',
    average:'Durchschnittswert',
    reviewsAvg:'Bewertungsdurchschnitt',
    Diff:'Diff',
    Hotel:'Das Hotel',
    Restaurant:'Restaurant',
    Reviews:"Bewertungen",
    Review:"Bewertung",
    Reply: "Antwort",
    Edit:"Bearbeiten",
    Add:"Add",
    engagements:"Interaktionen",
    Submit:"Einreichen",
    Title:"Titel",
    show_details:'Details anzeigen',
    Loading:'Laden',
    Load_failed:'Laden fehlgeschlagen',
    Report_not_ready:'Bericht noch nicht verfügbar',
    Report_not_ready_desc:'Dieser Zeitraum hat seinen Erstellungszeitpunkt noch nicht erreicht oder die Daten werden noch verarbeitet. Bitte schauen Sie später erneut vorbei.',
    Retry_after_refreshing:'Wiederversuchen nach der Erfrischung',
    LoadingData:'Daten laden',
    LoadingNewData:'Neue Daten laden',
    LoadingInitialData:'Erste Daten laden',
    Category:'Kategorie',
    copySuccess:'kopieren Erfolg!',
    Global:'Globale',
    Show_All:'Alle',
    SubcategoryAttention_title:'Bereichswarnung',
    SubcategoryAttention_tooltip:'Unterkategorien mit Werten unter 8.0, nach Gesamteinfluss sortiert. Bewertungen zeigen Neutralität + negative Anzahl. Einfluss = (Unterkategoriewert - Gesamtwert) × Bewertungsgewicht, misst, wie viel jeder Bereich den Gesamtwert nach unten oder nach oben zieht.',
    SubcategoryAttention_empty:'Alle Unterkategorien sind in gutem Zustand.',
    echartsNoData1:'Keine Daten für diesen Zeitraum verfügbar',
    echartsNoData2:'Bitte wählen Sie einen anderen Zeitraum aus oder versuchen Sie es später erneut, sobald neue Daten vorliegen',
    // WTK-578 图表空状态按原因区分（EchartsNoData 的 reason）
    echartsNoData_noScored1:'Keine bewerteten Rezensionen in diesem Zeitraum',
    echartsNoData_noScored2:'Der Verlauf zeigt nur Zeiträume mit bewerteten Rezensionen. Wählen Sie einen längeren Zeitraum, z. B. „Dieses Quartal“.',
    echartsNoData_noCategory1:'Keine Rezension erwähnt {category} in diesem Zeitraum',
    echartsNoData_noCategory2:'Wechseln Sie zurück zur Gesamtbewertung oder wählen Sie einen längeren Zeitraum, z. B. „Dieses Quartal“.',
    CategoryObj:{
        "Location & Neighborhood":"Lage & Umgebung",
        'Location & Neighbourhood':'Lage & Umgebung',
        Location:'Lage & Umgebung',

        "Cleanness":"Sauberkeit",
        "Cleanliness":"Sauberkeit",

        "Room Facilities & Comfort":"Zimmerkomfort",
        "Room Comfort":"Zimmerkomfort",
        'Room & Amenities':'Zimmerkomfort',
        Room:'Zimmerkomfort',

        'Hotel Atmosphere & Design':'Hotelausstattung & Atmosphäre',
        "Hotel Amenities & Atmosphere":"Hotelausstattung & Atmosphäre",

        "Food & Beverage":"Gastronomie",
        "F & B":"Gastronomie",
        "F&B":"Gastronomie",

        "Value for Money":"Preis-Leistungs-Verhältnis",
        'F&B Experience':'Gastronomie',
        'Hotel Facilities & Amenities':'Hotelausstattung & Atmosphäre',

        "Guest Experience & Service":"Gästeerlebnis & Service",
        Services:'Gästeerlebnis & Service',
        Service:'Gästeerlebnis & Service',
        Amenities:'Hotelausstattung & Atmosphäre',
        Value:'Preis-Leistungs-Verhältnis',

        'Brand Consistency & Expression':'Marke',
        Brand:'Marke',
        "Food Quality":"Lebensmittelqualität",
        "Beverage Quality":"Getränkequalität",
        "Service Quality":"Dienstleistungsqualität",
        "Ambience":"Umweltatmosphäre",
        "Cleanliness":"Sauberkeit",
        "Value Perception":"Preis-Leistungs-Verhältnis",
    },
    CategoryLabel:[
        {
            name1:"Alle Kategorien",
            name2:"Alle Kategorien",
            icon:'',
            icon1:'',
            value:"total",
            value1:"total",
            value2:"total",
        },
        {
            name1:"Standort",
            name2:"Lage & Umgebung",
            icon2:Group4,
            icon1:icon_Location,
            icon:Group1_1,
            value:"Location",
            value1:"location_neighbourhood",
            value2:"Location & Neighbourhood",
        },
        {
            name1:"Sauberkeit",
            name2:"Sauberkeit",
            icon2:Group2,
            icon1:icon_Cleanness,
            icon:Group2_1,
            value:"Cleanness",
            value1:"cleanliness",
            value2:"Cleanliness",
        },
        {
            name1:"Zimmer",
            name2:"Zimmerkomfort",
            icon2:Group3,
            icon1:icon_Room,
            icon:Group3_1,
            value:"Room",
            value1:"room_comfort",
            value2:"Room Comfort",
        },
        {
            name1:"Ausstattung",
            name2:"Hoteleinrichtungen & Atmosphäre",
            icon2:Group1,
            icon1:icon_Amenities,
            icon:Group4_1,
            value:"Amenities",
            value1:"hotel_amenities_atmosphere",
            value2:"Hotel Amenities & Atmosphere",
        },
        {
            name1:"F & B",
            name2:"Gastronomie",
            icon2:Group5,
            icon1:icon_FB,
            icon:Group6_1,
            value:"F & B",
            value1:"food_beverage",
            value2:"Food & Beverage",
        },
        {
            name1:"Dienstleistungen",
            name2:"Gästeerlebnis & Service",
            icon2:Group7,
            icon1:icon_Service,
            icon:Group5_1,
            value:"Service",
            value1:"guest_experience_service",
            value2:"Guest Experience & Service",
        },
        {
            name1:"Wert",
            name2:"Preis-Leistungs-Verhältnis",
            icon2:Group6,
            icon1:icon_Value,
            icon:Group7_1,
            value:"Value",
            value1:"value_for_money",
            value2:"Value for Money",
        },
        // {
        //     name1:"Marke",
        //     name2:"Marke",
        //     icon2:icon_Brand,
        //     icon1:icon_Brand1,
        //     icon:Group8_1,
        //     value:"Brand",
        //     value1:"brand_consistency_expression",
        // },
        {
            name1:"Lebensmittelqualität",
            name2:"Lebensmittelqualität",
            icon2:Food_Quality,
            icon1:Food_Quality,
            icon:Food_Quality,
            value:"Food Quality",
            value1:"food_quality",
        },
        {
            name1:"Getränkequalität",
            name2:"Getränkequalität",
            icon2:Beverage_Quality,
            icon1:Beverage_Quality,
            icon:Beverage_Quality,
            value:"Beverage Quality",
        },
        {
            name1:"Dienstleistungsqualität",
            name2:"Dienstleistungsqualität",
            icon2:Service_Quality,
            icon1:Service_Quality,
            icon:Service_Quality,
            value:"Service Quality",
        },
        {
            name1:"Umweltatmosphäre",
            name2:"Umweltatmosphäre",
            icon2:Ambience,
            icon1:Ambience,
            icon:Ambience,
            value:"Ambience",
        },
        {
            name1:"Preis-Leistungs-Verhältnis",
            name2:"Preis-Leistungs-Verhältnis",
            icon2:Value_For_Money,
            icon1:Value_For_Money,
            icon:Value_For_Money,
            value:"Value For Money",
            value1:"value_for_money",
            value2:"Value For Money",
        },
        {
            name1:"Cleanliness",
            name2:"Cleanliness",
            icon2:Group2,
            icon1:Cleanliness,
            icon:Group2_1,
            value:"Cleanliness",
            value1:"cleanliness",
        },
    ],
    CategoryLabel1:[
        {
            name1:"Alle Kategorien",
            name2:"Alle Kategorien",
            icon:'',
            icon1:'',
            value:"total",
            value1:"total",
        },
        {
            name1:"Standort",
            name2:"Lage & Umgebung",
            icon2:Group4,
            icon1:icon_Location,
            icon:Group1_1,
            value:"Location",
            value1:"location_neighbourhood",
        },
        {
            name1:"Sauberkeit",
            name2:"Sauberkeit",
            icon2:Group2,
            icon1:icon_Cleanness,
            icon:Group2_1,
            value:"Cleanness",
            value1:"cleanliness",
        },
        {
            name1:"Zimmer",
            name2:"Zimmerkomfort",
            icon2:Group3,
            icon1:icon_Room,
            icon:Group3_1,
            value:"Room",
            value1:"room_comfort",
        },
        {
            name1:"Ausstattung",
            name2:"Hoteleinrichtungen & Atmosphäre",
            icon2:Group1,
            icon1:icon_Amenities,
            icon:Group4_1,
            value:"Amenities",
            value1:"hotel_amenities_atmosphere",
        },
        {
            name1:"F & B",
            name2:"Gastronomie",
            icon2:Group5,
            icon1:icon_FB,
            icon:Group6_1,
            value:"F & B",
            value1:"food_beverage",
        },
        {
            name1:"Dienstleistungen",
            name2:"Gästeerlebnis & Service",
            icon2:Group7,
            icon1:icon_Service,
            icon:Group5_1,
            value:"Service",
            value1:"guest_experience_service",
        },
        {
            name1:"Wert",
            name2:"Preis-Leistungs-Verhältnis",
            icon2:Group6,
            icon1:icon_Value,
            icon:Group7_1,
            value:"Value",
            value1:"value_for_money",
        },
        {
            name1:"Marke",
            name2:"Marke",
            icon2:icon_Brand,
            icon1:icon_Brand,
            icon:Group8_1,
            value:"Brand",
            value1:"brand_consistency_expression",
        },
    ],
    RestaurantObj:{
        'Food Quality':'Lebensmittelqualität',
        'Taste & Flavor':'Geschmack und Geschmack',
        'Freshness':'Frische Zutaten',
        'Temperature':'Speisetemperatur',
        'Portion Size':'Portionsgröße',
        'Food Presentation':'Plattenpräsentation',
        'Menu Variety':'Menü Vielfalt',
        'Innovation & Uniqueness':'Kreativität und Eigenschaften',
        'General': 'Allgemeine',
        "View & Scenery":"Aussicht und Landschaft",
        "Beverage Quality":"Getränkequalität",
        "Taste & Preparation":"Geschmack und Herstellung",
        "Mixology Skill":"Mixing-Techniken",
        "Alcohol Selection":"Weinreichheit",
        "Non-Alcohol Selection":"Nicht-alkoholische Optionen",
        "Drink Presentation":"Getränke präsentiert",
        "Drink Menu & Variety":"Getränkekarte & Vielfalt",
        "Drink Innovation & Uniqueness":"Getränkekreativität & Eigenschaften",

        'Service Quality':'Dienstleistungsqualität',
        'Professionalism':'Professionelle Kompetenz',
        'Efficiency':'Leistungseffizienz',
        'Accuracy':'Genauigkeit',
        'Personalization':'Personalisierter Service',
        'Problem Resolution':'Problembehandlung',
        'Staffing & Team Coordination':'Zusammenarbeit von Menschen und Teams',
        'Bartender':'调酒师服务',
        'Reservation & Waiting':'Reservierung & Wartezeit',
        'Access, Arrival & Seating':'Zugang, Ankunft & Sitzplatzierung',
        'Guest Safety & Fair Treatment':'Gästesicherheit & faire Behandlung',

        "Ambience":'Umweltatmosphäre',
        "Decor & Design":'Dekorationsdesign',
        "Lighting":'Licht',
        "Music & Noise":'Musik und Lärm',
        "Air Quality":'Luftqualität',
        "Temperature & Ventilation":'Raumtemperatur und Belüftung',
        "Privacy":'Privatsphäre',
        "Seating Comfort":'Sitzkomfort',
        "Atmosphere":'Gefühl der Atmosphäre',
        "Facilities & Maintenance":'Einrichtungen & Instandhaltung',

        "Cleanliness":'Reinigung und Hygiene',
        "Tableware Hygiene":'Geschirrhygiene',
        "Dining Area":'Restaurant Umwelthygiene',
        "Restroom":'Toiletten und Geruch',
        "Staff Appearance":'Mitarbeitersauberkeit',
        "Kitchen & Food Handling":'Speisesaal',
        "Pest Control":'Schädlingsbekämpfung',

        "Value Perception":'Preis-Leistungs-Verhältnis',
        "Overall Worthiness":'Gesamtwertgefühl',
        "Quality & Service vs Price":'Qualität und Service',
        "Portion vs Price":'Portion- und Preisübereinstimmung',
        "Overall Satisfaction / Disappointment":'Gesamtgefühl',
        "Perceived Value vs Expectation":'Gesamtgefühl',
        "Price Transparency & Charging":'Preistransparenz & Abrechnung',
    },
    OTAs:{
        HOLIDAYCHECK:'HolidayCheck',
        HRS:'HRS',
        LASTMINUTE:'lastminute.com',
        TRIVAGO:'trivago',
        PRICELINE:'Priceline',
        HOTELSCOM:'Hotels.com',
        HOTELESCOM:'Hoteles.com',
        RAKUTEN:'Rakuten Travel',
        TRAVELOKA:'Traveloka',
        HOSTELWORLD:'Hostelworld',
        TRAVELOCITY:'Travelocity',
        ORBITZ:'Orbitz',
        LUXURYESCAPES:'Luxury Escapes',
        INTERNAL:'Internal',
        Internal:'Internal',
        MAKEMYTRIP:'MakeMyTrip',
        HOTELDE:'hotel.de',
        HolidayCheck:'HolidayCheck',
        Lastminute:'lastminute.com',
        Trivago:'trivago',
        Priceline:'Priceline',
        Hotelscom:'Hotels.com',
        Rakuten:'Rakuten Travel',
        Traveloka:'Traveloka',
        Hostelworld:'Hostelworld',
        Travelocity:'Travelocity',
        Orbitz:'Orbitz',
        LuxuryEscapes:'Luxury Escapes',
        MakeMyTrip:'MakeMyTrip',
        HotelDe:'hotel.de',
        BOOKING:'Booking.com',
        TRIP:'Ctrip.com',
        EXPEDIA:'Expedia',
        GOOGLE:'Google',
        TRIPADVISOR:'Tripadvisor',
        OPENTABLE:'OpenTable',
        YELP:'Yelp',
        WONGNAI:'Wongnai',
        AGODA:'Agoda',
        agoda:'Agoda',
        Booking:'Booking.com',
        Trip:'Ctrip.com',
        Google:'Google',
        Expedia:'Expedia',
        Tripadvisor:'Tripadvisor',
        Yelp:'Yelp',
        Wongnai:'Wongnai',
        'Google Map':'Google Map',
        'Open Table':'Open Table',
        'OpenTable':'Open Table',
    },
    baseLanguages:[
        { label: "Englisch", value: "English" },
        { label: "Deutsch", value: "German" },
        { label: "Französisch", value: "French" },
        { label: "Italienisch", value: "Italian" },
        { label: "Spanisch", value: "Spanish" },
        { label: "Portugiesisch", value: "Portuguese" },
        { label: "Schwedisch", value: "Swedish" },
        { label: "Chinesisch", value: "Chinese" },
        { label: "Japanisch", value: "Japanese" },
        { label: "koreanisch", value: "Korean" },
        { label: "Arabisch", value: "Arabic" },
        { label: "Russisch", value: "Russian" },
        { label: "Türkisch", value: "Turkish" },
        { label: "thailändisch", value: "Thai" },
        { label: "vietnamesisch", value: "Vietnamese" },
        { label: "Indonesisch / Bahasa", value: "Indonesian / Bahasa" },
        { label: "Niederländisch", value: "Dutch" },
        { label: "polnisch", value: "Polish" },
        { label: "Griechisch", value: "Greek" },
        { label: "Hebräisch", value: "Hebrew" },
    ],
    TravellerType:{
        "Couple":"Paare",
        "Solo":"Alleinrelsende",
        "Group":"Gruppen",
        "Family":"Familie",
        "Business":"Geschäftsreisende",
        "unknown":"unbekannt",
        "Unknown":"unbekannt",
        "UNKNOWN":"unbekannt",
        "FAMILY":"Familie",
        "COUPLE":"Paare",
        "SOLO":"Alleinrelsende",
        "GROUP":"Gruppen",
        "BUSINESS":"Geschäftsreisende",
    },
    punctuationMarks:{
        quotationMarks1:' " ',
        quotationMarks2:' " ',
    },
    subCategories:{
        local_cultural_expression:'Lokale Kulturausdruck',
        accessibility:"Erreichbarkeit",
        neighbourhood_facilities:"Umgebung",
        safety:"Sicherheit",
        views:"Aussicht",

        room_hygiene:"Zimmer",
        bathroom_hygiene:"Bad",
        public_area_hygiene:"Public Area",
        odour:"Geruch",
        restaurant_cleanness:"Restaurant",

        bed_quality:"Bett",
        sound_insulation:"Geräuschdämmung",
        air_conditioning_heating:"Klima / Heizung",
        room_size:"Größe",
        lighting:"Licht",
        shower_water_pressure:"Wasserdruck",
        room_design:"Design",
        room_maintenance:"Instandhaltung",
        in_room_amenities:"Ausstattung",

        wifi_internet:"Internet",
        // toKey("Wi-Fi & Internet") 得到的是 wi_fi_internet(连字符也会变成下划线),
        // 和上面那个历史 key 对不上,两个都留着。
        wi_fi_internet:"Internet",
        gym:"Fitnessraum",
        swimming_pool:"Schwimmbad",
        spa:"Spa",
        elevator:"Aufzug",
        business_centre:"Business Center",
        meeting_rooms:"Meeting Raum",
        car_parking:"Parking",
        executive_lounge:"Lounge",
        hotel_atmosphere_design:"Atmosphäre & Design",
        beach_outdoor_areas:"Strand & Außenbereiche",
        kids_family_facilities:"Kinder- & Familieneinrichtungen",

        breakfast:"Frühstück",
        restaurant:"Restaurant",
        bar:"Bar / Lounge",
        coffee_beverages:"Kaffee & Getränke",
        in_room_dining:"Room Service",
        service_and_efficiency:"Service & Ablauf",

        booking:"Buchung",
        membership_benefits:"Mitgliedschaft",
        // special_request_handling:"Behandlung von besonderen Anforderungen",
        personalised_request_handling:"Personalisierung",
        personalised_service:"Persönlicher Service",
        // front_desk_concierge:"Rezeption und Concierge-Service",
        concierge:"Concierge",
        check_in:"Check in",
        check_out:"Check out",
        in_room_request:"Zimmeranfrage",
        housekeeping:"Housekeeping",
        // cleaning_tidying:"Reinigung und Aufräumen",
        flexibility_guest_needs:"Flexibilität",
        flexibility_of_guest_needs:"Flexibilität",
        butler_service:"Butler-Service",
        hotel_transportation:"Hoteltransport",
        complaints_feedback:"Beschwerden",
        guest_treatment_fairness:"Gleichbehandlung",
        lounge_service:"Lounge Service",
        spa_gym_pool_service:"Spa / Gym / Pool Service",
        billing:"Abrechnung",
        points_arrival_speed:"Punkte Gutschrift",
        customer_service_response:"Antwortzeit",
        communication_language:"Kommunikation & Sprache",
        security_safety:"Sicherheit & Schutz",

        price_fairness:"Preis",
        experience_matching_price:"Erlebniswert",
        hidden_fees:"Zusatzgebühren",
        promotions_membership_benefits:"Aktionen",
        overall_satisfaction:"Zufriedenheit",
        // 接口在 Value for Money 下实际返回的是这个全称 key,SUBCATEGORY_MAP 里
        // 没有对应项,所以只能在这里单独补(缺了它界面会直接显示 i18n 路径原文)。
        overall_satisfactions_or_disappointments:"Zufriedenheit",

        general:'Allgemeine',
    },
    login:{
        Open_in_app_tip:'Der Zugriff auf diese Seite über ein Mobilgerät kann die Nutzung beeinträchtigen. Stattdessen die App öffnen?',
        Open_in_app_title:'Weiter zu Where to Know?',
        Open_in_app_subtitle:'Diese Seite funktioniert am besten in der Where to Know App',
        Open_in_app_button:'App öffnen',
        Reset_your_password:'Passwort zurücksetzen',
        Email_address:'E-Mail-Adresse',
        Log_in:'Anmelden',
        Reset_password:'Passwort zurücksetzen',
        Log_in_to_start_your_session:'Bei Ihrem Konto anmelden',
        placeholder1:'E-Mail-Adresse',
        placeholder2:'Passwort',
        Remember_me:'Angemeldet bleiben',
        module_hotel:'Hotel',
        module_restaurant:'Restaurant',
        module_brand:'Marke',
        Forget_your_password:'Passwort vergessen?',
        Back_to_login:'Zurück zur Anmeldung',
        Send_reset_link:'Reset-Link senden',
        Password_requirements:'Passwortanforderungen:',
        Password_requirements1:'muss eine Zahl, einen Großbuchstaben',
        Password_requirements2:'und einen Kleinbuchstaben enthalten',
        Verify_your_email:'Überprüfen Sie Ihre E-Mail',
        Verify_your_email1:"Wir haben Ihnen einen sechsstelligen Registrierungscode per E-Mail geschickt",
        Verify_your_email2:"Geben Sie den Code unten ein",
        Email_me_another_verification_code:"E-Mail mir einen anderen Verifizierungscode",
        Repeat_new_password:"Neues Passwort wiederholen",
        Are_you_sure_you_want_to_logout:'Sind Sie sicher, dass Sie sich abmelden möchten',
        Confir_Logout:'Abmelden bestätigen',
        Confirm:'Bestätigen',
        Cancel:'Abbrechen',
        Current_password_is_incorrect:'Aktuelles Passwort ist falsch',
    },
    Region:[
        {
            label:'Globale',
            value:'GLOBAL',
            icon1:global,
        },
        {
            label:'Groß-China',
            value:'GREATER_CHINA',
            icon1:CHINA,
        },
        {
            label:'APAC ex China',
            value:'APAC_EX_CHINA',
            icon1:APAC,
        },
        {
            label:'Mittlerer Osten',
            value:'MIDDLE_EAST',
            icon1:MIDDLE_EAST,
        },
        {
            label:'Europa',
            value:'EUROPE',
            icon1:EMEA,
        },
        {
            label:'Afrika',
            value:'AFRICA',
            icon1:AFRICA,
        },
        {
            label:'Nordamerika',
            value:'NORTH_AMERICA',
            icon1:N_A,
        },
        {
            label:'Südamerika',
            value:'SOUTH_AMERICA',
            icon1:SOUTH_AMERICA,
        },
    ],

    geo:{
        global:'Global',
        americas:'Amerika',
        north_america:'Nordamerika',
        latin_america:'Lateinamerika',
        emea:'EMEA',
        europe:'Europa',
        middle_east:'Naher Osten',
        africa:'Afrika',
        apac:'Asien-Pazifik',
        southeast_asia:'Südostasien',
        japan:'Japan',
        korea:'Korea',
        australia_pacific:'Australien & Pazifik',
        india:'Indien & Südasien',
        greater_china:'Groß-China',
        mainland_china:'Festlandchina',
        hong_kong:'Hongkong',
        taiwan:'Taiwan',
        macau:'Macau',
    },

    selectHotel:{
        Select_Your_Hotel:"Wählen Sie ein Hotel aus",
        Select_Your_Restaurant:"Wählen Sie ein Restaurant aus",
        Select_Your_Brand:"Wählen Sie eine Marke aus",
        Choose_any_of_the_following_hotels:"Wählen Sie ein Hotel aus, um fortzufahren",
        Choose_a_restaurant_to_continue:"Wählen Sie ein Restaurant aus, um fortzufahren",
        Choose_a_brand_to_continue:"Wählen Sie eine Marke aus, um fortzufahren",
        Loading_hotels:"Hotels laden",
        Confirm_Continue:"Bestätigen & Fortsetzen",
        Need_assistance_Contact_support:"Benötigen Sie Hilfe? Kontaktieren Sie den Support",
    },
    current:{
        Date:"Heutiges Datum:",
        Updated:"Lokale Zeit:",
    },
    chat:{
        title:'Intelligenz',
        welcomeTitle:'Frag mich alles zu deinen Bewertungsdaten',
        welcomeSub:'Analyse-Assistent · Beta',
        betaNotice:'KI-generierte Antworten sollten anhand Ihrer Dashboard-Daten überprüft werden.',
        betaNoticeL1:'Der KI-Assistent befindet sich noch in der Beta-Phase und Antworten können gelegentlich ungenau sein.',
        betaNoticeL2:'Wichtige Erkenntnisse sollten stets anhand Ihrer Dashboard-Daten verifiziert werden.',
        betaBadge:'KI-Assistent (Beta)',
        quotaWarnDay:'Etwa {pct}% des heutigen KI-Assistent-Kontingents dieses Hotels sind verbraucht — Zurücksetzung morgen.',
        quotaWarnMonth:'Etwa {pct}% des KI-Assistent-Kontingents dieses Hotels für diesen Monat sind verbraucht — Zurücksetzung am 1.',
        thinking:'Denkprozess',
        steps:'Schritte ({n})',
        analyzing:'Bewertungen werden analysiert…',
        newChat:'Neuer Chat',
        delete:'Löschen',
        deleteConfirm:'Diese Unterhaltung löschen? Das kann nicht rückgängig gemacht werden.',
        deleted:'Unterhaltung gelöscht',
        feedbackUp:'Hilfreich',
        feedbackDown:'Nicht hilfreich',
        copy:'Kopieren',
        copied:'Kopiert',
        copyFailed:'Kopieren fehlgeschlagen',
        unknownUser:'Unbekannter Benutzer',
        byAuthor:'von {name}',
        groupToday:'Heute',
        groupYesterday:'Gestern',
        groupLast7:'Letzte 7 Tage',
        groupLast30:'Letzte 30 Tage',
        groupOlder:'Älter',
        insightsTitle:'{n} Punkte diese Woche zu prüfen',
        insightsBadge:'Aufmerksamkeitsübersicht',
        insightsUrgent:'{n} mit hoher Priorität',
        insightsCta:'Worauf sollte ich mich konzentrieren?',
        periodSwitch:'Zeitraum:',
        period7d:'Letzte 7 Tage',
        periodMonth:'Dieser Monat',
        periodQuarter:'Dieses Quartal',
        periodYtd:'Seit Jahresbeginn',
        samePeriod:'Gleiche Frage für {period}',
        insightsView:'KI fragen',
        insightsAsk:'Welche Anomalien wurden zuletzt markiert? Bitte Ursachen und Empfehlungen erläutern.',
        evidence:'Quellen',
        hideEvidence:'Ausblenden',
        evidenceHint:'Klicke auf die Markierung „Quellen“ unter einer Antwort, um zu sehen, worauf sie beruht.',
        viewReportPdf:'Report-PDF öffnen',
        reportPdfError:'Report-PDF konnte nicht geöffnet werden. Bitte erneut versuchen.',
        evReviews:'Bewertungen',
        evReports:'Berichte',
        evWeb:'Web',
        viewOnSource:'Original ansehen',
        viewSource:'Quelle ansehen',
        expandReview:'Mehr anzeigen',
        collapseReview:'Weniger anzeigen',
        placeholder:'Frage eingeben – Enter zum Senden (Umschalt+Enter für Zeilenumbruch)',
        suggestions:[
            'Gibt es Auffälligkeiten, die ich kennen sollte?',
            'Warum sind unsere Bewertungen diesen Monat schlechter geworden?',
            'Erreichen wir diesen Monat unsere Ziele?',
            'Wie stehen wir im Vergleich zu den Wettbewerbern da?',
            'Welche Mitarbeiter wurden diesen Monat am häufigsten gelobt – und wofür genau?',
            'Gibt es lokale Events oder News, die die Nachfrage beeinflussen?',
        ],
        tools:{
            query_metrics:'Kennzahlen abfragen',
            list_reviews:'Bewertungen laden',
            render_chart:'Diagramm erstellen',
            load_skill:'Analysemethode laden',
        },
    },
    DateTimePickerHome:{
        label1:'Letzte Woche',
        label2:'Letzter Monat',
        label3:'Letzte 3 Monate',
        label4:'Dieses Jahr',
        Last_7_days:'Letzte 7 Tage',
        Last_Month:'Letzter Monat',
        Current_Month:'Dieser Monat',
        Current_Quarter:'Dieses Quartal',
        Current_Year:'Dieses Jahr',
        Custom:'Benutzerdefiniert',
        allFrequencyOpts:[
            { value: "DAY", displayLabel: "Tag" },
            { value: "WEEK", displayLabel: "Woche" },
            { value: "MONTH", displayLabel: "Monat" },
        ]
    },
    HotelIndex:{
        title:'Hotel Dashboard',
        FilterSheet:{
            OtaPlatform:'OTA-Plattform',
            DateRange:'Zeitraum',
            DateFrequency:'Datum & Häufigkeit',
            DateToolbar:'Datum & Werkzeugleiste',
            Apply:'Anwenden',
            More:'Mehr',
        },
        PackageBanner:{
            regionLabel:'Hinweis zum Abonnement',
            viewPlans:'Pläne ansehen',
            contactSales:'Vertrieb kontaktieren',
            trialEnded:'Ihre kostenlose Testversion endete am {date}',
            trialEndsOn:'Ihre kostenlose Testversion endet am {date}',
            daysRemaining:'noch {days} Tage',
            readOnlyPurgeNoDays:'Nur-Lese-Zugang bis zur Datenlöschung',
        },
        Platform_Overview:{
            title:'1. Plattformübersicht',
            tooltip:'Dieser Bereich wird wöchentlich aktualisiert',
            tooltip1:'Die Antwortrate und die durchschnittliche Antwortzeit sind Beispieldaten. Nach Aktivierung der Integration werden die tatsächlichen Daten Ihres Hotels angezeigt.',
            text2:"Antwortquote:",
            Reviews:"Bewertungen",
            Reviews1:"Bewertungen:",
            ReviewCount:"Bewertung | Bewertungen",
            text3:"Durchschnittliche Antwortzeit",
            text4:"days",
            notAvailable:"Nicht verfügbar",
            unknown:"Unbekannt",
            noResponsesYet:"Noch keine Antworten",
            lessThanOneDay:"< 1 Tag",
            text5:"Gäste:",
            text6:"Gesamt-Engagements",
            title1:"Morgen-Überblick",
            text7:'Data loading failed. Please try reloading later',
            otherPlatforms:'Weitere Plattformen',
            moveToExpanded:'In die Übersicht verschieben',
            replaceWith:'Ersetzen durch',
            moreCount:'+{count} weitere',
            showAll:'Alle anzeigen',
            compactView:'Kompakte Ansicht',
            manageSources:'Quellen verwalten',
            searchSourcesPlaceholder:'Quellen suchen...',
            featuredSection:'Hervorgehoben ({count})',
            otherSourcesSection:'Weitere Quellen ({count})',
            moveToFeatured:'Hervorheben',
            cancel:'Abbrechen',
            save:'Speichern',
            noSearchResults:'Keine Quellen für "{query}" gefunden',
            ReviewBySources:{
                'Direct booking':'Direkebuchung',
                DirectBookingSurvey:'Direkebuchung (Unfrage)',
                DirectbookingText:'Die hier angezeigten Daten sindnur Richtwerte. Exakte Zahlen undBenchmarks werden sichtbar.sobald lhre Integration aktiv ist',
                'Information Platforms':'Informationsplattformen',
                OTAs:'OTAs',
                'Social Media':'Social Media',
                Directbooking:'Direkebuchung',
                InformationPlatforms:'Informationsplattformen',
                SocialMedia:'Social Media',
            },
            ScoreImprovement:{
                current:'Aktuell',
                target:'Ziel',
                title:'Bewertungsverbesserung',
                subtitle:'Schieberegler ziehen um Zielpunktzahl festzulegen',
                reviewsNeeded:'Höchstbewertungen bis',
                projectionDisclaimer:'Prognose basierend auf bisherigen Bewertungsmustern. Ergebnisse können abweichen.',
                maxScoreReached:'Maximalbewertung erreicht',
                alreadyAbove:'Bereits am oder über dem Ziel',
                noData:'Keine Bewertungsdaten verfügbar',
                predicted:'voraussichtlich',
                assuming:'Angenommene Bewertung neuer Reviews',
                targetLabel:'Zielpunktzahl',
                analyzing:'Analysieren',
                estimatedAt:'Geschätzt',
                month:'Monat',
                months:'Monate',
                estimatedTooltip:'Basierend auf dem Durchschnitt der letzten 3 Monate; höheres Volumen oder mehr 5-Sterne-Bewertungen können den Zeitrahmen verkürzen.',
                // ── Steady-State-Modell (aktueller Durchschnitt) ──
                ceilingLabel:'Akt. Durchschnitt',
                ceilingTooltip:'Eine Plattformbewertung ist ein gleitender Durchschnitt: der Mittelwert Ihrer letzten Bewertungen ist der Wert, auf den sie zuläuft — und die Grundlage dafür, ob die Bewertung als stabil oder unter Druck gilt. Bei der aktuellen Bewertungsqualität endet die Bewertung hier — über diese Linie kommt man mit besseren, nicht mit mehr Bewertungen.',
                beyondCeilingHint:'Ziel liegt über der erreichbaren Grenze',
                week:'Woche',
                weeks:'Wochen',
                year:'Jahr',
                moreThanDuration:'mehr als {duration}',
                // ── Vier-Szenarien-Modell: Status / theoretische Schwelle / realistische Dauer ──
                badgeHealthy:'Stabil',
                badgeAtRisk:'Unter Druck',
                badgeUnknown:'Unzureichende Daten',
                maintainHealthy:'{score} lässt sich derzeit stabil halten',
                maintainAtRisk:'{score} könnte auf {ceiling} fallen',
                maintainAtRiskNoCeiling:'{score} lässt sich möglicherweise nicht halten',
                maintainUnknown:'Bewertungsstabilität noch nicht einschätzbar',
                stabilityLabel:'Bewertungsstabilität',
                cannotAssessYet:'Noch nicht einschätzbar',
                barToTarget:'Bis {target}: etwa {count} Höchstbewertung | Bis {target}: etwa {count} Höchstbewertungen',
                barNearMax:'Bereits nahe am Maximum',
                barUnavailable:'Schätzung nicht verfügbar',
                timeExpected:'Etwa {duration}',
                timeMoreThan:'Mehr als {duration}',
                timeNoData:'Zeitschätzung nicht verfügbar',
                timeUnreachableAtAverage:'Beim aktuellen Durchschnitt derzeit nicht erreichbar',
                requiredAvgNote:'Neue Bewertungen müssen im Schnitt über {required} liegen',
            },
        },
        Performance_Analytics:{
            title:"2. Leistungsanalyse",
            tooltip1:'Dieser Bereich wird täglich aktualisiert',
            title1:"Gesameleistung",
            text1:'Customize KPI',
            label1:"Top 5 Stärken",
            label2:"Top 5 Verbesserungsbereiche",
            label3:"Top Gästemärkte",
            label4:"Reisetypen",
            card1:"Zimmerkomfort",
            card2:"Sauberkeit",
            tooltip2:'Bitte wählen Sie einen anderen Zeitraum oder eine andere Frequenz',
            tooltip3:'No improvement areas data available',
            categoryGoalsTitle:"Kategorie-Ziele vs. Leistung",
            categoryGapTitle:"Kategorie-Lückentabelle",
            text2_1:'Ziele',
            text2:'Performance',
            Score_details:"Punktzahldetails",
            Comparison_options:"Vergleichsoptionen：",
            YoY:"Vergleich zum Vorjahr",
            MoM:"Vergleich zum Vormonat",
            WoW:"Im Vergleich zur letzten Woche",
            QoQ:"Vergleich zum letzten Quartal",
            'current_period':'Diese Periode',
            'previous_period':'Vorheriger Zeitraum',
            'the_same_period_last_year':'Im gleichen Zeitraum des letzten Jahres',
            cirpieTooltip:'Weitere KPIs definieren (z. B. Golf, Tennis, Hochzeiten, Tagungen), um Hotelschwerpunkte zu verfolgen',
            Specific_classification:"Spezifische Klassifizierung",
            No_of_reviews:"Reviews",
            impact:"Einfluss",
            No_of_reviews_tooltip:"Unzureichende Bewertungen beeinflussen die Bewertung des Systems",
            Insufficient_reviews:"Unzureichende Bewertungen",
            No_reviews:"Keine Bewertung",
            WTK_score_8:"WQI ≥ 8",
            WTK_score_6:"5 ≤ WQI < 8",
            WTK_score_4:"WQI < 5",
            eye_tooltip:{
                Positive:'positiv',
                Neutral:'neutral',
                Negative:'negativ',
                PositiveQTY:'Positive',
                NeutralQTY:'Neutral',
                NegativeQTY:'Negative',
                quantity:' Menge',
                Reviews_ratio:'Verhältnis',
                ReviewsBySubcategory:'Reviews by subcategory',
                sort:'Sortieren nach',
                score:'Score',
                review:'Zahl',
            },
            country_tooltip:'Bitte beachten Sie, dass nicht alle Datenquellen Informationen zur Herkunft der Gäste liefern, sodass die hier angezeigten.',
        },
        Current_Situation:{
            title:"Aktuelle Lage",
            Select_report_type:'Berichtstyp auswählen',
            Low_Data:'Niedrige Konfidenz',
            Low_Data_Tooltip:'Geringe Stichprobengröße — Erkenntnisse sind nur richtungsweisend und spiegeln möglicherweise nicht die allgemeine Gästemeinung wider.',
            Medium_Data:'Mittlere Konfidenz',
            Medium_Data_Tooltip:'Moderate Stichprobengröße — Ergebnisse zeigen aufkommende Trends, sollten aber im Kontext interpretiert werden.',
            High_Data:'Hohe Konfidenz',
            High_Data_Tooltip:'Große Stichprobengröße — Ergebnisse sind statistisch belastbar und repräsentativ für die Gästemeinung.',
            Total_reviews:'Gesamtzahl der Kommentare',
            Strengths : "Positiv: WQI > 8",
            Areas_for_improvement : "Negativ: WQI < 7",
            Top_5_Positive:'Top 5 Positiv',
            Top_5_Negative:'Top 5 Negativ',
            Week:'Woche',
            Month:'Monat',
            HalfMonth:'Halbmonat',
            Quarter:'Quartals',
            HalfYear:'Halbjährig',
            Year:'Jahr',
            Last_period:'Vorheriger Zyklus',
            Next_period:'Nächster Zyklus',
            Comment_Ratio:"Bewertungsquote",
            Highlight:"Wichtigste Stärken",
            Issue:"Wichtigste Schwächen",
            Trend_overview:"Trendübersicht",
            Total_Score_Overview:"Gesamtbewertung",
            AI_Score_Tooltip:"Basierend auf der semantischen Analyse aller Bewertungen durch Where to Know AI, nicht einfach die OTA-Plattformbewertungen.",
            Historical_data:"Verlauf",
            Current_month_data:"Aktueller Monat",
            Top_Lists:"Rangliste",
            frequency:"Frequenz",
            Category_Summary:"Kategorie Zusammenfassung",
            Category_Insights:"Kategorie Einblicke",
            category_tab_short:{
                Location:"Lage",
                Cleanness:"Sauberkeit",
                Room:"Zimmer",
                Amenities:"Hotel-Ausstattung",
                F_and_B:"F & B",
                Service:"Service",
                Value:"Preis-Leistung",
                Food_Quality:"Essen",
                Beverage_Quality:"Getränke",
                Service_Quality:"Service",
                Ambience:"Ambiente",
                Cleanliness:"Sauberkeit",
                Value_For_Money:"Preis-Leistung",
            },
            Expand_All:"Alle aufklappen",
            Collapse_All:"Alle einklappen",
            Positive_insight:"Positive Erkenntnis",
            Negative_insight:"Negative Erkenntnis",
            Positive_insights:"Positive Erkenntnisse",
            Negative_insights:"Negative Erkenntnisse",
            Recommended_Action:"Empfohlene Maßnahme",
            Tips_for:"Tipps für",
            noIssuesReported:"Keine Probleme gemeldet",
            provenance_view_one:'Basierend auf {n} Bewertung',
            provenance_view_other:'Basierend auf {n} Bewertungen',
            provenance_title:'Bewertungsnachweis',
            provenance_supporting:'Unterstützende Bewertungen',
            // 类别行显示的是该类别的评论总数，抽屉里只列支撑这一条洞察的那几条 ——
            // 两个数字不一样是对的，但不说明白就像是哪边算错了。
            provenance_subset: '{shown} von {total} Bewertungen in {subject} stützen diesen Punkt',
            provenance_partial:'{shown} von {total} angezeigt: einige Bewertungen sind nicht mehr verfügbar.',
            provenance_forbidden:'Sie haben keinen Zugriff auf diese Bewertungen.',
            provenance_none:'Keine dieser Bewertungen ist mehr verfügbar.',
            provenance_failed:'Die Bewertungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
            Management_Focus:"Management-Fokus",
            From_Insights_to_Action:'Von Erkenntnissen zur Aktion',
            From_Insights_to_Action1:'Management Focus für den Zeitraum',
            Solution :"Management-Maßnahme",
            Solution_Sub :"Operative Prioritäten für den nächsten Zeitraum",
            Overall_Solution :"Gesamtlösungen",
            Maintain :"Wartung",
            Resolve :"lösen",
            Category_Solution :"Kategorien Lösungen",
            Category_Solution_Text :"Diese Daten sind unzureichend. Aktuelle Überwachung behalten",
            insufficient_data:"Zu wenige Daten",
            Next_refresh:'Nächste Aktualisierung',
            Medium_3_5_mentions:'Mittelwertiges Datenvolumen (3-5 Erwähnungen), Einsichten können begrenzt sein',
            Low_3_mentions:"Niedriges Datenvolumen (<3 Erwähnungen), Einsichten begrenzt",
            limitedData:'Begrenzte Daten, möglicherweise nicht repräsentativ',
            period_Insufficient:'Nicht ausreichende Daten in diesem Zeitraum. Aktuelle Überwachung aufrechterhalten',
            period_Insufficient1:'Für die folgenden Kategorien liegen in diesem Zeitraum nur begrenzte Daten vor. Bitte weiter beobachten',
            Top_5_Positives:'Top-Positives',
            Top_5_Positives_text1:'Keine Top-Positiven für diesen Zeitraum',
            Top_5_Positives_text2:'Es gibt nicht genug einheitlich positive Erwähnungen, um eine Rangliste zu bilden.',
            Top_5_Negatives:'Top-Negatives',
            Top_5_Negatives_text1:'Keine Top-Negativmeldungen für diese Periode',
            Top_5_Negatives_text2:'Es gibt nicht genug einheitlich negative Erwähnungen, um eine Rangliste zu bilden.',
            Friendly_staff:'Freundliches personal',
            Trend:'Trend',
            Comment:'Meinung',
            Trend_Insight:'Einblick',
            Performance_Trend:'Leistungstrend',
            Expand_All:'Alle ausklappen',
            Collapse_All:'Alle einklappen',
            totalReviews_one:"{n} Bewertung",
            totalReviews_other:"{n} Bewertungen",
            Total_reviewsTooltip:'Diese Zahl entspricht der Gesamtzahl der Bewertungen, einschließlich aller Bewertungen, die nur eine Wertung enthalten. Daher kann die Anzahl der von der WTK KI analysierten Bewertungen geringer sein als diese Zahl, was zu einer natürlichen Abweichung von der Gesamtzahl der Bewertungen führt',
            reviewsTextAnalysed_one:"{n} Bewertung mit Text analysiert",
            reviewsTextAnalysed_other:"{n} Bewertungen mit Text analysiert",
            reviewsTextAnalysedTooltip:"Bewertungen mit Text, die von der WTK KI analysiert wurden. Bewertungen nur mit Wertung enthalten keinen Text, daher kann diese Zahl unter der Gesamtzahl der Bewertungen liegen.",
            reviewsMentionCategory_one:"{n} Bewertung analysiert",
            reviewsMentionCategory_other:"{n} Bewertungen analysiert",
            reviewsMentionCategoryTooltip:"Analysierte Bewertungen, die diese Kategorie erwähnen. Eine Bewertung kann mehrere Kategorien erwähnen, daher ergibt die Summe nicht die Gesamtzahl der analysierten Bewertungen.",

            Market_View_Competitive_Summary:'Marktblick & Wettbewerbsfähigkeit Zusammenfassung',
            Market:'Markt',
            Competitive_Dimensions:'Wettbewerbsdimension',
            Execution_Signature:'Signatur ausführen',
            Experience_Boosters_By_Competitors:'Verbesserte Erfahrung durch Wettbewerber',
            Guest_Desire:'Wünsche der Gäste',
            Execution:'Ausführen',
            Takeaway:'Ausverkauf',
            Operational_Challenges:'Betriebliche Herausforderungen',
            Share_Trigger_Landscape:'Freie Triggerumgebung',
            Action_Focus:'Aktionsfokus',
            Overall_Direction:'Allgemeine Richtung',
            Category_Solutions:'Kategorien Lösungen',
            Defensive_Offensive_Moves:'Druck und Wettbewerbsvorteile',
            Defensive_Moves:'Wettbewerbsdruck',
            Offensive_Moves:'Wettbewerbsvorteile',
            Competitor_Patterns:'Konkurrenzmodell',
            Strategic_Playbook:'Strategisches Playbook',
            Portfolio:{
                Tabs_Restaurant:'Restaurant',
                Tabs_Portfolio:'Aggregated',
                Critical_Items:'Kritische Punkte',
                Competitor_Alerts:'Wettbewerbswarnungen',
                Cross_Outlet_Comparison:'Vergleich über alle Outlets',
                Category:'Kategorie',
                Signal:'Signal',
                Standout_Positive:'Herausragend Positiv',
                Standout_Negative:'Herausragend Negativ',
                Portfolio_Wide_Issue_Label:'Portfolio-weites Thema:',
                Outlet_Digest:'Outlet-Zusammenfassung',
                Strength_Label:'Stärke:',
                Concern_Label:'Problem:',
                Watch_Label:'Beobachten:',
                Portfolio_Actions:'Portfolio-Maßnahmen',
                Review_Generation_Recommendations:'Empfehlungen zur Review-Generierung',
                Status_Requires_Immediate_Attention:'Sofortige Aufmerksamkeit erforderlich',
                Status_Monitor_Closely:'Eng überwachen',
                Status_No_Action_Required:'Keine Maßnahme erforderlich',
                Status_Insufficient_Data:'Unzureichende Daten',
                Signal_Strong:'stark',
                Signal_Mixed:'gemischt',
                Signal_Weak:'schwach',
                Signal_Insufficient_Data:'unzureichende Daten',
                Unknown_Outlet:'Unbekanntes Outlet',
                Staff_Positive_Outlet_Ranking:'Top 10 Mitarbeiter nach positiven Erwähnungen',
                Ranking_Staff_Name:'Mitarbeiter',
                Ranking_Outlet_Name:'Outlet',
                Staff_Positive_Total:'Positiv',
                Staff_Negative_Total:'Negativ',
                Staff_Mentions_Total:'Erwähnungen gesamt',
                Staff_Positive_Ranking_Empty:'Keine Outlet-Dynamikdaten für diesen Zeitraum.',
            },
        },
        Staff_Mentions_Leaderboard:{
            View_By_Name:'Nach Name',
            View_By_Division:'Nach Abteilung',
            Sentiment_All:'Alle anzeigen',
            title:'Mitarbeiter Erwähnungen Leaderboard',
            empty_title:'In diesem Zeitraum wurden keine Mitarbeitenden erwähnt',
            empty_hint:'Wählen Sie einen längeren Zeitraum, z. B. letzten Monat oder aktuelles Quartal.',
            Updated:'Aktualisiert',
            Rank:'Rang',
            Name:'Name',
            Last_mention:'Letzte Erwähnung',
            Total_mentions:'Total',
            MoM:'Mutter',
            Positive:'Positiv',
            Negative:'Negativ',
            Positive_Ratio:'Positives Verhältnis',
            Review_date:'Bewertung',
            Show_More:'Mehr anzeigen',
            Show_All:'Alle anzeigen',
            Show_Less:'Weniger anzeigen',
            MTD:'MTD',
            Finalized:'Abgeschlossen',
            Export_CSV:'CSV exportieren',
            Export_Type:'Typ',
            Export_Source:'Quelle',
            Export_Reviewer:'Bewerter',
            Export_Mention_Sentiment:'Stimmung der Erwähnung',
            Export_Evidence:'Beleg',
            Export_Review:'Bewertung',
            Export_Review_Link:'Link zur Bewertung',
            popoverTitle:'Hinweis:',
            popoverText:"Diese Bewertung ist der WQI auf einer Skala von 1 bis 10, die von der ursprünglichen Bewertung der Gastquelle abweichen kann.",
        },
        LastWeekTopLists:{
            title:'Die Top-Liste der letzten Woche',
            Type:'Typ',
            Positive:'Positiv',
            Negative:'Negativ',
            emptyState:'Keine Daten verfügbar. Möglicherweise gibt es nicht genug Bewertungen aus der letzten Woche.',
            notEnoughWritten:'Letzte Woche gab es zu wenige Bewertungen mit Text, um die Listen zu erstellen. Bewertungen nur mit Sternen enthalten keinen Text zur Analyse.',
            generating:'Die Listen der letzten Woche werden gerade erstellt. Schauen Sie bald wieder vorbei.',
        },
        Activity24h:{
            title:'Jüngste Aktivität',
            past24h:'Live',
            review:'Bewertung',
            reviews:'Bewertungen',
            analysed:'analysiert',
            reviewDetails:'Bewertungsdetails',
            positive:'Positiv',
            negative:'Negativ',
            positiveLower:'positiv',
            negativeLower:'negativ',
            withContent:'mit Text',
            ratingOnly:'nur Bewertung',
            sentiment:'Stimmung',
            contentLabel:'Inhalt',
            riskSignals:'Risikosignale',
            noReviews:'Keine neuen Bewertungen in den letzten 72 Stunden.',
            monitoring:'Überwachung läuft weiter.',
            viewMore:'Mehr anzeigen',
            viewLess:'Weniger anzeigen',
            noMatchingReviews:'Keine passenden Bewertungen gefunden.',
            emptyPositive:'Keine positiven Bewertungssignale in der jüngsten Aktivität erkannt.',
            emptyNegative:'Keine negativen Bewertungssignale in der jüngsten Aktivität erkannt.',
            positiveReviews:'Positive Bewertungen',
            negativeReviews:'Negative Bewertungen',
            wtkScoreLabel:'WQI',
            syncHint:'Neue Bewertungen werden hier analysiert und angezeigt, sobald sie eingehen. Je nach Plattform-Synchronisation kann es zu leichten Verzögerungen kommen.',
            riskSignalLabels:{
                extremely_low:'Score-Warnung',
                negative_only:'Nur negative Rückmeldungen',
                rating_discrepancy:'Score-Abweichung',
            },
            riskSignalTooltips:{
                extremely_low:'Bewertungen, die Ihren individuell festgelegten Warn-Schwellenwert erreichen oder unterschreiten. Sie können diesen Schwellenwert in den Einstellungen anpassen, um relevante Bewertungen im Blick zu behalten.',
                negative_only:'Nur negativ bedeutet, dass die Bewertung ausschließlich negatives Feedback enthält – unabhängig vom Gesamtscore.',
                rating_discrepancy:'Score-Abweichung bedeutet, dass die Gästebewertung und das KI-Analyseergebnis erheblich voneinander abweichen.',
            },
            reviewSummary:'Zusammenfassung',
            guestRating:'Gästebewertung',
            guestReview:'Bewertung',
            openOriginalReview:'Originalbewertung öffnen',
            relatedReview:'zugehörige Bewertungen',
            nightUnit:'Nacht | Nächte',
        },
        RoomTypeBreakdown:{
            rtbTitle:'Zimmertyp',
            positive:'Positiv',
            negative:'Negativ',
            total:'Gesamt',
            showing:'Anzeige {visible} von {total}',
            popover:'Der Zimmertyp konnte in {identified} von {total} Bewertungen ermittelt werden ({coverage}%). Die meisten Google- und TripAdvisor-Bewertungen enthalten keine Angaben zum Zimmertyp.',
            filterAll:'Alle',
            empty:'Für diesen Zeitraum wurden keine zimmerbezogenen Daten gefunden.',
            positiveMentions:'Positive Erwähnungen',
            negativeMentions:'Negative Erwähnungen',
            relatedReview:'zugehörige Bewertungen',
            expandMore:'+{count} weitere',
            collapse:'Weniger anzeigen',
        },
    },
    RestaurantDashboard:{
        title:'Restaurant Dashboard',
        Platform_Overview:{
            title:'1. Plattformübersicht',
            tooltip1:'Antwortrate und durchschnittliche Antwortzeit sind Beispieldaten. Nach der Integration zeigt das System die echten Daten.',
        },
        Performance_Analytics:{
            title:'2. Leistungsanalyse',
        },
        Selected_Restaurant:'Restaurant auswählen',
        Performance_Highlights:'Leistung Highlights',
        Overall_Performance:'Gesamtleistung',
        Food_Quality:'Lebensmittelqualität',
        Beverage_Quality:'Getränkequalität',
        Service_Quality:'Dienstleistungsqualität',
        Ambience:'Ambiente',
        Cleanliness:'Sauberkeit',
        Value_For_Money:'Preis-Leistungs-Verhältnis',
        Sarai:'Sarai',
        Istros:'Istros',
        Review_sources:'Quellen überprüfen',
        botList:{
            Top_5_Positive_Mentions:'Top 5 Positive Erwähnungen',
            Top_5_Negative_Mentions:"Top 5 Negative Erwähnungen",
        },
        Food_Beverage_Mentions_Leaderboard:'Ernährung & Getränke Erwähnungen Leaderboard',
        Food:"Nahrung",
        Beverage:"Getränke",
        Show_all:"Alle anzeigen",
        LastMonthTopLists:{
            title:"Top-Listen des letzten Monats",
            Type:"Typ",
            Positive:"Positiv",
            Negative:"Negativ",
            emptyState:"Keine Daten verfügbar. Möglicherweise gibt es nicht genügend Bewertungen vom letzten Monat.",
            notEnoughWritten:"Letzten Monat gab es zu wenige Bewertungen mit Text, um die Listen zu erstellen. Bewertungen nur mit Sternen enthalten keinen Text zur Analyse.",
            generating:"Die Listen des letzten Monats werden gerade erstellt. Schauen Sie bald wieder vorbei.",
        },
    },
    ReviewsTitle:{
        // WTK-727: publish a reply on Google
        PostToGoogle: "Auf Google veröffentlichen",
        PostToGoogleConfirm: "Diese Antwort wird auf Google als öffentliche Antwort Ihres Betriebs auf diese Bewertung veröffentlicht. Jetzt veröffentlichen?",
        PostToGoogleConfirmButton: "Veröffentlichen",
        PostToGoogleCancel: "Abbrechen",
        PostedToGoogle: "Antwort auf Google veröffentlicht",
        PostToGoogleFailed: "Die Antwort konnte nicht auf Google veröffentlicht werden",
        // WTK-730: preview before posting, edit a reply on Google
        EditOnGoogle: "Auf Google bearbeiten",
        UpdateOnGoogleConfirm: "Der folgende Text ersetzt Ihre aktuelle Antwort auf Google. Jetzt speichern?",
        SaveToGoogle: "Auf Google speichern",
        UpdatedOnGoogle: "Antwort auf Google aktualisiert",
        // WTK-820: who replied from WhereToKnow
        ReplyLogPosted: "{name} hat diese Antwort über WhereToKnow auf Google veröffentlicht · {time}",
        ReplyLogEdited: "{name} hat die Antwort auf Google über WhereToKnow bearbeitet · {time}",
        ReplyLogFailed: "{name} wollte auf Google veröffentlichen, es schlug fehl · {time}",
        ReplyLogShow: "Verlauf ({n})",
        ReplyLogHide: "Verlauf ausblenden",
        ReplyLogSomeone: "Ein Kollege",
        // WTK-743: reply on Tripadvisor through its Management Center
        ReplyOnTripadvisor: "Auf Tripadvisor antworten",
        TripadvisorReplyCopied: "Antwort kopiert. Fügen Sie sie auf der geöffneten Tripadvisor-Seite ein und senden Sie sie dort ab, angemeldet als Manager des Eintrags. Tripadvisor prüft Antworten vor der Veröffentlichung.",
        TripadvisorReplyCopyFailed: "Tripadvisor wurde geöffnet, die Antwort konnte aber nicht kopiert werden. Bitte kopieren Sie sie hier.",
        title:'Bewertungen & Antworten',
        avgResponseTime:"durchschnittliche Antwortzeit",
        Unreplied:"Nicht beantwortet:",
        Flagged:"Markiert:",
        ScoreColorGuide:'Bewertungsfarbleitfaden',
        Business_Traveller:'Geschäftsreisender',
        placeholder1:"Sprache auswählen",
        Translation:"Übersetzung",
        Translating:"Übersetzen",
        Original:"Original",
        GuestUser:"Gastbenutzer",
        Stay:"Aufenthalt:",
        Review:"Bewertung:",
        GoToTheReview:"Zur Bewertung",
        Search_Match_Count:"{count} passende Bewertungen",
        Search_Match_Summary:"{mentions} in {reviews}",
        Search_Mentions_Count:"{n} Erwähnung | {n} Erwähnungen",
        Search_Reviews_Count:"{n} Bewertung | {n} Bewertungen",
        Search_Sort_Mentions:"Erwähnungen",
        Search_Sort_Mention_Asc:"Erwähnungen: aufsteigend",
        Search_Sort_Mention_Desc:"Erwähnungen: absteigend",
        Search_Sort_Default:"Standard-Sortierung",
        Review_Keyword_Mentioned:"In dieser Bewertung {count}-mal erwähnt",
        ReadMore:"Mehr lesen",
        ShowLess:"Weniger anzeigen",
        text4:"Typenanteil",
        text5:"KI-Antwort",
        text51:"Antwort",
        text6:"Generieren",
        text7:"Beareiten",
        text8:"Senden",
        Reply:'Antwort',
        Copy:'Kopieren',
        Replied:'Beantwortet',
        Forward:'Weiterleiten',
        ForwardTo:'Weiterleiten an',
        ForwardCancel:'Abbrechen',
        ForwardSend:'Senden',
        ForwardNoStaff:'Noch keine Mitarbeiter',
        ForwardNoPermission:'Sie haben keinen Zugriff auf die Mitarbeiterliste. Wenden Sie sich an einen Admin dieses Betriebs.',
        ForwardUseWtk:'Über WTK senden',
        ForwardNotePlaceholder:'Erklären Sie, warum Sie diese Bewertung an einen Kollegen weiterleiten … (optional)',
        ForwardSendViaWtk:'Über WTK senden',
        ForwardSending:'Wird gesendet …',
        ForwardSent:'Über WTK gesendet',
        Ratings_only:'Nur Bewertungen',
        Ratings_only_tooltip:'Dieser Gast hat nur eine Sternebewertung ohne Kommentar abgegeben, daher gibt es keinen Text für die KI-Analyse.',
        filters:{
            title:'Filters',
            Review_Mode:'Bewertungsmodus',
            Review_Mode1:'Gästebewertung',
            Score_Scale_Note:'10-Punkte-Skala. Bewertungen von 5-Sterne-Plattformen werden verdoppelt (5★ = 10).',
            Review_Mode2:'Kl-Einblicke',
            Review_ModeNote:'Info-Hinweis',
            Review_ModeNote1:'Nur Kommentare mit Textinhalt anzeigen(Kommentare ohne Text wurden ausgeblendet)',
            Review_Type:'Bewertungstyp',
            Review_Type1:'Alle Bewertungen',
            Review_Type2:'Mit Text',
            Review_Type3:'Nur Bewertungen',
            Review_Type1_disabled:'Nicht verfügbar im Modus "Nur mit Text".',
            Sentiment_Status:'Sentiment-Status',
            Source_Language:'Bewertungssprache',
            Source_Language_Placeholder:'Alle Sprachen',
            Summary_Type:'Zusammenfassungstyp',
            Summary_TypeObj:{
                IncludePositive:'Inkl. positiv',
                IncludeNegative:'Inkl. negativ',
                PositiveOnly:'Nur positiv',
                NegativeOnly:'Nur negativ',
            },
            Review_Status:'Kommentarstatus',
            Review_StatusLabels:[
                {
                    label:'Positiv',
                    value:'Positive',
                },
                {
                    label:'Negativ',
                    value:'Negative',
                },
                {
                    label:'Score-Abweichung',
                    value:'RatingDiscrepancy',
                },
            ],
            Categories:'Kategorien',
            Sort:'Sortieren',
            Sort_By:'Sortieren nach',
            Sort_Time:'Zeit',
            Sort_Score:'Bewertung',
            Sort_Weight:'Gewicht',
            Sort_Time_Newest:'Neueste zuerst',
            Sort_Time_Oldest:'Älteste zuerst',
            Sort_Score_High:'Hoch bis niedrig',
            Sort_Score_Low:'Niedrig bis hoch',
            Sort_Weight_Highest:'Höchstes Gewicht',
            sortObj:{
                'Time (newest first)':'Zeit (neueste zuerst)',
                'Time (oldest first)':'Zeit (älteste zuerst)',
                'Score (high to low)':'Bewertung (höchste zuerst)',
                'Score (low to high)':'Bewertung (niedrigste zuerst)',
                'Weight (highest first)':'Weight (niedrigste zuerst)',
            },
            Reply_Status:'Antwortstatus',
            Reply_StatusObj:{
                'Replied':'Beantwortet',
                'Pending':'Nicht beantwortet',
            },
            Apply:'Anwenden',
            Cancel:'Abbrechen',
            Reset:'Zurücksetzen',
            Status:'Status',
            Status_Labels:[
                {
                    label:'Gespeicherte Antwort',
                    value:'SavedReply',
                },
                {
                    label:'Mit Notizen',
                    value:'WithNotes',
                },
            ],
            Meal_Time:'Mahlzeit',
            mealTime:{
                Lunch:'Mittagessen',
                Dinner:'Abendessen',
                Brunch:'Brunch',
                LUNCH:'Mittagessen',
                DINNER:'Abendessen',
                BRUNCH:'Brunch',
                BREAKFAST:'Frühstück',
                OTHER:'Sonstiges',
            },
            Dining_Mode:'Essensart',
            diningMode:{
                DineIn:'Vor Ort',
                TakeOut:'Zum Mitnehmen',
                DINE_IN:'Vor Ort',
                TAKE_OUT:'Zum Mitnehmen',
            },
            Experience_Attributes:'Erlebnisattribute',
            experienceAttr:{
                NoiseLevel:'Lautstärke',
                Quiet:'Ruhig',
                Moderate:'Mäßig',
                Loud:'Laut',
                QUIET:'Sehr ruhig',
                MODERATE:'Mäßige Geräuschkulisse',
                LOUD:'Laut, aber man kann noch reden',
                NOT_SURE:'Nicht sicher',
                GroupSize:'Gruppengröße',
                Solo:'Allein',
                Couple:'Paar',
                SmallGroup:'Kleine Gruppe',
                LargeGroup:'Große Gruppe',
                SOLO:'1 Person',
                COUPLE:'2 Personen',
                SMALL_GROUP:'3-4 Personen',
                LARGE_GROUP:'5-8 Personen',
                ALL:'Für alle Gruppengrößen geeignet',
                SeatingType:'Sitzart',
                Indoor:'Innen',
                Outdoor:'Außen',
                Bar:'Bar',
                INDOOR:'Innenbereich',
                OUTDOOR:'Außenterrasse / Patio',
                BAR:'Barbereich',
                BOOTH:'Nischen-Sitzplatz',
                COUNTER:'Thekenplatz',
                PRIVATE:'Privater Speiseraum',
            },
        },
        noReviews1:'Für den ausgewählten Zeitraum/Quelle gibt es keine Bewertungen. Bitte setzen Sie den',
        noReviews2:'Filter zurück und versuchen Sie es erneut',
        WTKscore:'WQI:',
        WTKscore1:'Berechnet auf der Grundlage einer fortgeschrittenen KI-Sentimentanalyse',
        Note:"Hinweis",
        NoteText:"Diese Bewertung enthält keine geschriebenen Rückmeldungen. Die Antwort wird ausschließlich auf der Basis der Bewertung generiert und kann daher generischer sein.",
        NoteText1:"Dieser Kommentar wird derzeit analysiert. Sobald die Analyse abgeschlossen ist, wird die Antwortfunktion verfügbar sein.",
        Summary:'Zusammenfassung',
        LoadTheCommentData:'Kommentardaten laden',
        CategoryWeight:'Kategoriegewicht',
        CopyAllSections:'Alle Abschnitte kopieren',
        showTranslatedContent:"Keine Übersetzungsdaten für die aktuelle Antwort. Klicken Sie, um später zu übersetzen",
        showOriginalContent:'Aktuelle Antwort hat keine "Original"-Daten. Klicken Sie zum Übersetzen',
        Pending_analysis:'Die analyse wartet',
        Pending_analysis_tooltip:'Diese Bewertung wird derzeit anhand der Benchmark für die Hotelkategorie analysiert. Die Ergebnisse werden in Kürze angezeigt',
        Pending_analysis_tooltip1: 'Diese Bewertung geht über den Zeitraum Ihres aktuellen Abonnements hinaus. Bitte kontaktieren Sie uns, wenn Sie den Umfang der Analyse erweitern möchten',
        Reply_pending_tooltip:'Antworten ist möglich, sobald die Analyse dieser Bewertung abgeschlossen ist',
        Rating_discrepancy:'Score-Abweichung',
        Rating_discrepancy_tooltip:'Die semantische Analyse dieses Kommentars weicht von den Nutzerbewertungsergebnissen ab und erfordert mehr Aufmerksamkeit seitens des Verwaltungsteams.',
        Rating_mismatch_single:'{dimensions} Bewertungsabweichung',
        Rating_mismatch_multi:'{dimensions} Abweichung',
        Discrepancy_dimension:{
            Service:'Service',
            Food:'Essen',
            Atmosphere:'Atmosphäre',
            Beverage:'Getränke',
            Cleanliness:'Sauberkeit',
            Value:'Wert',
        },
        Unknown:'Unbekannt',
        Switch_to_list_mode:'Wechseln zum Listenmodus',
        Switch_to_preview_mode:'Wechseln in den Vorschaumodus',
        Export_Excel:'Excel exportieren',
        // WTK-573 筛选栏图标说明 / 重置按钮
        Filters_Tip:'Filter',
        Filters_Active_Tip:'Filter (aktiv)',
        Search_Tip:'Suchen',
        Reset_Filters:'Zurücksetzen',
        Keyword_Search_Placeholder:'Bewertungstext durchsuchen…',
        Filter_Sheet_Period:'Zeitraum',
        Filter_Sheet_Keyword:'Suchbegriff',
        Expand:'Ausdehnen',
        Collapse:'Falten',
        Has_internal_note:'Hat interne Notiz',
        This_reviews_has_been_saved:'Diese Bewertung wurde gespeichert',
        Note_deleted:'Notiz gelöscht',
    },
    Replies:{
        title:'Antworteinstellungen',
        Hotel_Name_Usage:{
            title:'Verwendung des Hotelnamens',
            title1:'Hotelname',
            input1:'Hotelnamen eingeben',
        },
        Restaurant_Name_Usage:{
            title:'Restaurantname Verwendung',
            title1:'Restaurantname',
            input1:'Restaurantnamen eingeben',
        },
        Tone:{
            title:'Ton',
            label1:'Markenvorgabe',
            label2:'Formalität',
            label3:'Kontraktionen',
            label4:'Emoji',
            label5:'Humor',
            label6:'Ausrufezeichenlimit',
            label7:'Hotelnamen verwenden',
            label7_restaurant:'Restaurantnamen verwenden',
            option1:[
                {
                    label:'Formal elegant',
                    value:'formal_elegant',
                },
                {
                    label:'Premium warm',
                    value:'premium_warm',
                },
                {
                    label:'Casual verspielt',
                    value:'casual_playful',
                },
                {
                    label:'Minimal neutral',
                    value:'minimal_neutral',
                },
            ],
            option2:[
                {
                    label:'Mittel',
                    value:'medium'
                },
                {
                    label:'Hoch',
                    value:'high'
                },
            ],
            option3:[
                {
                    label:'Niedrig',
                    value:'low'
                },
                {
                    label:'Mittel',
                    value:'medium'
                },
            ],
            showData1:[
                'Niedrig: „Danke für Ihr Feedback! Wir freuen uns, dass Sie Ihren Aufenthalt genossen haben“',
                'Mittel: „Vielen Dank für Ihr Feedback. Wir freuen uns zu hören, dass Sie Ihren Aufenthalt bei uns genossen haben“',
                'Hoch: „Wir danken Ihnen aufrichtig für Ihr wertvolles Feedback und freuen uns, dass Ihr Aufenthalt angenehm war“'
            ],
            showData2:'Ich bin, Ich bin',
            showData3:'Kontrolle der Intensität des eigenen Humorsinns',
            showData4:'Die maximale Anzahl zulässiger Ausrufezeichen',
            showData5:'Hotelnamen in Antworten enthalten (an) oder nicht (aus)',
        },
        LanguageRules:{
            title:'Sprachregeln',
            label1:'Sprachpräferenz',
            label2:'Pronomenstil',
            radio1:[
                {
                    text1:'Auto',
                    text2:'（Folgt automatisch der Sprache der Gästebewertungen）',
                    value:'auto'
                },
                {
                    text1:'Fest',
                    text2:'（Antwortet immer in der angegebenen Sprache）',
                    value:'fixed'
                },
            ],
            option1:[
                {
                    label:'Formal',
                    value:'formal'
                },
                {
                    label:'Informell',
                    value:'informal'
                },
            ],
            alertTitle:'Hinweis',
            alertData:'Wenn Sie „Zwingende Bezeichnung“ auswählen, werden Antworten immer in der gewählten Sprache generiert, auch wenn der Gast seine Bewertung in einer anderen Sprache verfasst hat. Dies kann inkonsistent erscheinen',
            showData1:'Nur in Sprachen mit formalen/informellen Pronomen verfügbar (Deutsch, Französisch, Italienisch, Chinesisch)',
        },
        WordPreferences:{
            title:'Wortpräferenzen',
            label1:'Bevorzugte Wörter',
            label2:'Wörter vermeiden',
            tagInput1:['Team','Erlebnis'],
            tagInput2:['Patronage','Hiermit'],
        },
        Title:{
            title:'Titel',
            label1:'Begrüßungsstil',
            label2:'Standardbegrüßung',
            option1:[
                {
                    label:'Hallo  [Benutzername]',
                    value:'Hi [Username]',
                },
                {
                    label:'Guten Tag [Benutzername]',
                    value:'Hello [Username]',
                },
                {
                    label:'Sehr geehrter [Benutzername]',
                    value:'Dear [Username]',
                },
                // {
                //     label:'Benutzerdefiniert',
                //     value:'Custom',
                // },
            ],
            option2:[
                {
                    label:'Sehr geehrter Gast',
                    value:'Dear Guest',
                },
                {
                    label:'Hallo Reisender',
                    value:'Hello Traveler',
                },
                // {
                //     label:'Benutzerdefiniert',
                //     value:'Custom',
                // },
            ],
        },
        MainBody:{
            title:'Hauptteil',
            title1:'Intelligente Antworten',
            label1:'Text',
            label2:'Kategorie',
            label3:'Thema',
            label4:'Trigger-Stichwörter',
            label5:'Aktionen',
            button1:'Hinweis hinzufügen',
            emptyText:'+ Fügen Sie Ihre erste Smart Note hinzu',
            showData1:'Notizen werden automatisch basierend auf Schlüsselwörtern und semantischem Abgleich ausgelöst, und jede Notiz erscheint nur einmal',
            placeholder3:"Neues Thema erstellen",
            placeholder4:"Optionen suchen oder hinzufügen",
            placeholder5:"+hinzufügen",
            delTitle:'Bestätigung löschen',
            delTitleTooltip:'Nach dem Löschen werden die Daten nicht wiederhergestellt. Bitte handeln Sie vorsichtig.',
            cancelBtn:'stornieren',
            delBtn:'löschen',
            SaveTitle:'Änderungen speichern',
            SaveTitleTooltip:'Der geänderte Inhalt wurde nicht gespeichert. Muss ich sie speichern?',
            Do_not_save:'Nicht speichern',
            Do_not_save1:'Nicht speichern',
            Save:'speichern',
        },
        Ending:{
            title:'Schluss',
            label1:'Rückkehraufforderung',
            label2:'Unterschrift',
            radio1:[
                {
                    text1:'Immer zurück einladen',
                    text2:'Jede Antwort enthält eine Einladung zurückzukehren',
                    value:"always_invite_back"
                },
                {
                    text1:'Einladen bei positiven oder gemischten Rückmeldungen',
                    text2:'Nur einladen, wenn der Kommentar des Gastes positiv oder neutral ist',
                    value:"invite_on_positive_or_mixed_feedback"
                },
                {
                    text1:'Intelligente Einladung (KI entscheidet)',
                    text2:'KI entscheidet; keine Einladung in eindeutig negativen Fällen',
                    value:"smart_invite"
                },
            ],
            placeholder1:"Fügen Sie hier den Namen Ihres Teams oder Managers hinzu",
            placeholder2:'"Das Gastrelations-Team", "Ihr London Hotel"',
        },
        ReplyLength:{
            title:'Antwortlänge',
            radio1:[
                {
                    text1:'Kurz (30-60 Wörter)',
                    text2:' (Schnell und einfach: geeignet für OTA-Plattformen)',
                    value:"short",
                },
                {
                    text1:'Standard (60-100 Wörter)',
                    text2:' (Ausgewogen und professionell: empfohlene Standardeinstellung)',
                    value:"standard",
                },
                {
                    text1:'Detailliert (100-140 Wörter)',
                    text2:' (ideal für offizielle Webseiten oder E-Mail-Antworten)',
                    value:"detailed",
                    showTooltip: true
                },
                {
                    text1:'Dynamisch (KI passt automatisch an)',
                    text2:' (Flexible Länge; die sich der Bewertung des Gastes anpasst)',
                    value:"dynamic",
                },
            ],
        },
        button1:'Vorschau',
        button2:'Einstellungen speichern',
        Preview:{
            title:'Vorschau',
            label1:"Titel",
            label2:"Anfang",
            label3:"Haupttext",
            label4:"Schluss",
            button1:'abbrechen',
            button2:'bestätigen',
        },
        notes:{
            Notes:'Bemerkung',
            internal:'intern',
            No_internal_notes_yet:'Es gibt noch keine interne Anmerkung.',
            Add_note:'Hinweis hinzufügen',
            Only_visible_to_your_team:'Nur für Ihr Team sichtbar',
            placeholder:'Fügen Sie eine Analyse, Handhabungsanmerkungen oder Nachfolgeaktionen für diesen Kommentar hinzu…',
            Cancel:'stornieren',
            Save:'speichern',
            Delete:'Löschen',
            Edit:'Bearbeiten',
            Delete_Text:'Die Daten sind nach der Löschung unwiederbringlich verloren. Bitte handeln Sie mit Vorsicht.',
            Delete_note:'Notiz löschen',
        },
        Reply_Saved:'Antwort gespeichert',
        Reply_Saved_text:'Ihre Antwort wurde gespeichert. Sie finden sie im Abschnitt "Antwortbibliothek".',
    },
    competitors:{
        title:'Konkurrenten',
        title1:'Ausgewählte Hotels：',
        title1_restaurant:'Ausgewählte Restaurants：',
        title2:'Durchschnittsbewertung von OTA-Plattformen',
        title3:'Hotel insgesamt',
        title31:'Hotel Standalone Score',
        title31_restaurant:'Restaurant Standalone Score',
        Relative_Performance:'Relative Performance',
        Relative_Performance_tooltip_title:'Hinweis: ',
        Relative_Performance_tooltip:'Der relative Performancesindex wird berechnet, indem Ihre eigenständige Gesamtpunktzahl durch die Durchschnittspunktzahl der Wettbewerber geteilt wird. Ein Wert unter 1,0 bedeutet, dass Sie unter dem Durchschnitt der Wettbewerber liegen, während ein Wert über 1,0 bedeutet, dass Sie über dem Durchschnitt der Wettbewerber liegen.',
        Under_performance:'Unterleistung',
        Over_performance:'Überleistung',
        label3_1:'Ihr Hotel insgesamt',
        label3_1_restaurant:'Ihr Restaurant insgesamt',
        title4:'Konkurrent',
        title5:'Übersicht der Bewertungen',
        'score':'Gesamtwertung',
        'Total_reviews':'Bewertungen insgesamt',
        'location_neighbourhood':'Lage & Umgebung',
        'cleanliness':'Sauberkeit',
        'room_comfort':'Zimmerkomfort',
        'hotel_amenities_atmosphere':'Hoteleinrichtungen & Atmosphäre',
        'food_beverage':'Gastronomie',
        'guest_experience_service':'Gästeerlebnis & Service',
        'value_for_money':'Preis-Leistungs-Verhältnis',
        'food_quality':'Essensqualität',
        'beverage_quality':'Getränkequalität',
        'service_quality':'Servicequalität',
        'ambience':'Ambiente',
        'value_perception':'Wertempfindung',
        'your_hotel':'Ihr Hotel',
        // 手机：OTA 平台平均得分（按平台切换的排名列表）
        ota_reviews:'{n} Bewertungen',
        ota_vs_you_up:'{n} über Ihnen',
        ota_vs_you_down:'{n} unter Ihnen',
        ota_vs_you_same:'Gleich wie Sie',
        ota_no_score:'Keine Bewertung',
        ota_platforms:'Plattformen',
        // 手机分析区筛选入口：「最近一月 · 6 家酒店」
        hotels_count:'{n} Hotels',
        restaurants_count:'{n} Restaurants',
        averageTooltip:'Die durchschnittliche Bewertung von Konkurrenzhotels außer Ihrem Hotel',
        diffTooltip:'Der Unterschied zwischen der Bewertung Ihres Hotels und dem Durchschnitt Ihrer Wettbewerber',
        title6:'Kategorie:',
        lowSampleTooltip:'Kleine Stichprobe (n={n}) — nur als Richtungsangabe, statistisch nicht belastbar',
        wow:{
          title:'Veränderungen Woche für Woche',
          tooltip:'Vergleicht den aktuellen Zeitraum mit dem vorherigen gleich langen Zeitraum. Hotels mit einer Stichprobe < 10 zeigen die Veränderung in gedämpftem Stil — nur als Richtungsangabe zu interpretieren.',
          colHotel:'Hotel',
          colRestaurant:'Restaurant',
          lastWeek:'Letzte Woche',
          thisWeek:'Diese Woche',
          change:'Veränderung',
          you:'Sie',
          lowSample:'Kleine Stichprobe (n={n}) — Veränderung nur als Richtungsangabe',
        },
        title61:'Kategorieleistung',
        compareLabel:'Vergleichszeitraum',
        compareStartPlaceholder:'Startdatum',
        compareEndPlaceholder:'Enddatum',
        compareVs:'vs',
        compareSamePeriodHint:'Bitte wählen Sie einen anderen Zeitraum',
        viewPrevPeriodReviews:'Bewertungen des Vergleichszeitraums anzeigen',
        compare:'Vergleich',
        bySentiment:'Nach Sentiment',
        byCategory:'Nach Kategorie',
        topic:'Thema',
        review:'Bewertung',
        byTopic:'Nach Thema',
        byNumber:'Nach Anzahl',
        period:'Zeitraum',
        previousValueLabel:'Vergleichszeitraum',
        currentValueLabel:'Aktuell',
        changeLabel:'Änderung',
        title7:'Zusammenfassung',
        label7_1:'Herkunft',
        label7_2:'Vorschlag',
        label7_3:'Problem',
        title8:'Kundenreise',
        title9:'Bewertungsübersicht nach Quellen',
        title9_1_1:'Kommentarquellen',
        label9_1:'Soziale Medien',
        label9_2:'Vorschau-Modus',
        title10:'Soziale Medienplattform',
        label10_1:'Gesamte Engagement',
        title11:'Länder / Gebiete',
        title12:'Reisende-Typ',
        My_Top_5_Markets:'Meine Top 5 Märkte',
        My_Top_5_Markets_Tooltip:'Jede Bar zeigt % der Gesamtgäste dieses Hotels (nicht kumulativ)',
        Competitors_Top_5_Markets:'Top 5 Märkte der Wettbewerber',
        Competitors_Top_5_Markets_Tooltip:'Länder, deren Gästeanteil in Wettbewerbshotels über 10% höher ist als in Ihrem Hotel',
        Source_Filter_Placeholder:'Quelle: Alle',
        Source_All_Option:'Alle Quellen',
        Market_Overlap:'Marktüberlappung',
        Dominant_Markets:'Dominante Märkte',
        Missed_Opportunities:'Vermisste Gelegenheiten',
        Average_of_competitors:'Durchschnittliche Wettbewerber',
        echarts2Tooltip:'Anteil der Gesamtgäste jedes Hotels (nicht additiv):',
        Insight_Box:'Insight Box',
        Insight_Box_text:'Ihr Hotel zieht mehr Familienreisende (32%) und Paare (28%) an als Ihre Mitbewerber, während es weniger Geschäftsgäste hat',
        no_Data_Tooltip:'Dieses Hotel verfügt über keine Daten zu dieser Kategorie für den ausgewählten Zeitraum.',
        Sentiment_Evolution:'Score-Trend',
        competitor_avg:'Wettbewerber Ø',
        ScoreTrend_Compare:'Vergleichen',
        ScoreTrend_None:'Keiner',
        ScoreTrend_PreviousPeriod:'Vorheriger Zeitraum',
        ScoreTrend_LastMonth:'Letzter Monat',
        ScoreTrend_SamePeriodLastYear:'Gleicher Zeitraum letztes Jahr',
        ScoreTrend_CustomRange:'Benutzerdefinierter Zeitraum',
        ScoreTrend_CurrentRange:'Aktueller Zeitraum',
        ScoreTrend_CompareRange:'Vergleichszeitraum',
        ScoreTrend_Current:'Aktuell',
        ScoreTrend_CompareSeries:'Vergleich',
        ScoreTrend_ScoreBelowThreshold:'Wert < Schwellenwert',
        ScoreTrend_CurrentAvg:'Aktueller Ø',
        ScoreTrend_CompareAvg:'Vergleichs-Ø',
        ScoreTrend_Difference:'Differenz',
        ScoreTrend_PercentChange:'Prozentuale Änderung',
        ScoreTrend_NoComparisonData:'Keine Vergleichsdaten',
        ScoreTrend_VsPreviousPeriod:'vs. vorheriger Zeitraum',
        ScoreTrend_VsLastMonth:'vs. letzter Monat',
        ScoreTrend_VsLastYear:'vs. letztes Jahr',
        ScoreTrend_VsCustomRange:'vs. benutzerdef. Zeitraum',
        ScoreTrend_LastMonthNote:'Ø über den gesamten Kalendermonat; der Trend zeigt nur überlappende Tage.',
        ScoreTrend_Apply:'Anwenden',
        ScoreTrend_Back:'Zurück',
        // 评论证据抽屉（CompetitorCategoryDrawer）里按大类分组的短名
        topicShort:{
            Location:'Lage',
            Cleanliness:'Sauberkeit',
            Room:'Zimmer',
            Atmosphere:'Atmosphäre',
            FB:'F & B',
            Service:'Service',
            Value:'Preis-Leistung',
            Other:'Sonstiges',
        },
    },
    StaffManagement:{
        title:'Mitarbeiterverwaltung',
        addStaff:'Mitarbeiter hinzufügen',
        email:'E-Mail',
        username:'Benutzername',
        name:'Name',
        role:'Rolle',
        status:'Status',
        actions:'Aktionen',
        editRoles:'Rollen bearbeiten',
        edit:'Bearbeiten',
        // 手机列表「更多」菜单：只能查看的账号（集团账号、自己）用这个代替「编辑」
        viewDetails:'Details anzeigen',
        department:'Abteilung',
        departmentPlaceholder:'Abteilung auswählen',
        allDepartments:'Alle Abteilungen',
        post:'Position',
        postPlaceholder:'Position eingeben (z. B. Front Office Manager)',
        suspend:'Sperren',
        delete:'Löschen',
        active:'Aktiv',
        suspended:'Gesperrt',
        confirmSuspendTitle:'Diesen Mitarbeiter sperren?',
        confirmSuspendBody:'Der Mitarbeiter kann sich danach nicht mehr anmelden. Sie können ihn jederzeit wieder aktivieren.',
        confirmDeleteTitle:'Aus diesem Betrieb entfernen?',
        confirmDeleteBody:'Die Person verliert den Zugriff auf diesen Betrieb. Dies kann nicht rückgängig gemacht werden.',
        cancel:'Abbrechen',
        confirm:'Bestätigen',
        save:'Speichern',
        emailPlaceholder:'z.B. name@ihrhotel.de',
        rolesPlaceholder:'Rolle(n) auswählen',
        searchPlaceholder:'Name, E-Mail oder Rolle suchen',
        statusAll:'Alle',
        noStaff:'Noch keine Mitarbeiter',
        addSuccess:'Erfolgreich hinzugefügt',
        suspendSuccess:'Gesperrt',
        deleteSuccess:'Entfernt',
        rolesUpdateSuccess:'Rollen aktualisiert',
        loadFailed:'Laden fehlgeschlagen. Bitte erneut versuchen.',
        emailRequired:'Bitte E-Mail eingeben',
        invalidEmail:'Bitte eine gültige E-Mail-Adresse eingeben, z.B. name@ihrhotel.de',
        emailExists:'Diese E-Mail steht bereits in Ihrer Mitarbeiterliste',
        addFailed:'Mitarbeiter konnte nicht hinzugefügt werden. Bitte erneut versuchen.',
        actionFailed:'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
        currentUser:'Angemeldet als',
        you:'Ich',
        cannotChangeSelf:'Ihr eigenes Konto können Sie nicht ändern, sperren oder löschen',
        lastAdmin:'Mindestens ein aktiver Admin muss erhalten bleiben',
        noPermissionTitle:'Nur Admins können Mitarbeiter verwalten',
        noPermissionDesc:'Wenden Sie sich an einen Admin dieses Betriebs, um Mitarbeiter hinzuzufügen oder zu ändern.',
        updateSuccess:'Gespeichert',
        rolesRequired:'Bitte eine Rolle auswählen',
        staffTitle:'Mitarbeiter',
        peopleCount:'{n} Person | {n} Personen',
        inviteStaff:'Mitarbeiter einladen',
        sendInvite:'Einladung senden',
        saveChanges:'Änderungen speichern',
        close:'Schließen',
        removeFromProperty:'Aus dem Betrieb entfernen',
        permissionsCount:'{n} Berechtigungen',
        whatRoleCanDo:'Was {role} darf',
        compareRoles:'Rollen vergleichen',
        currentRole:'Aktuelle Rolle: {role}. Wählen Sie oben eine Rolle, um sie zu ändern.',
        noRoles:'Keine Rollen verfügbar',
        rolesTitle:'Rollen und Berechtigungen',
        rolesIntro:'Was jede Rolle in diesem Betrieb darf.',
        permissionsIncluded:'Enthaltene Berechtigungen',
        included:'Enthalten',
        notIncluded:'Nicht enthalten',
        scope:'Bereich',
        lastLogin:'Letzte Anmeldung',
        scopeProperty:'Dieser Betrieb',
        scopeBrand:'Marke',
        scopePortfolio:'Portfolio',
        groupTag:'Gruppe',
        groupCount:'{n} Gruppenkonto | {n} Gruppenkonten',
        groupNote:'Gruppenkonten gelten für mehrere Betriebe. Sie werden von Where to know eingerichtet und sind hier schreibgeschützt.',
        // 集团账号详情抽屉（只读）
        accessibleProperties:'Zugängliche Betriebe',
        propertyCount:'{n} Betrieb | {n} Betriebe',
        propertyListPending:'Die Liste der Betriebe ist noch nicht verfügbar.',
        neverActive:'Nie',
        // 同一组几个权限之间的分隔符
        listSeparator:', ',
        // 权限显示名，键是权限代码（后端 labelEn / labelZh 是技术名，这里写给酒店用户看的说法）
        perm:{
            READ_DASHBOARD:'Übersicht ansehen',
            READ_REVIEW:'Bewertungen ansehen',
            READ_NEED_ATTENTION:'Fälle ansehen',
            MANAGE_NEED_ATTENTION:'Fälle bearbeiten',
            READ_REPLY_LIBRARY:'Antwortbibliothek ansehen',
            MANAGE_REPLY_LIBRARY:'Antwortbibliothek bearbeiten',
            READ_REPLY:'Antworteinstellungen ansehen',
            MANAGE_REPLY:'Antworteinstellungen bearbeiten',
            READ_COMPETITORS:'Wettbewerbsübersicht',
            READ_COMPETITORS_REVIEW:'Bewertungen der Wettbewerber',
            READ_REPORT:'Berichte ansehen',
            EXPORT_REPORT:'Bericht als PDF herunterladen',
            EXPORT_REPORT_EXCEL:'Daten exportieren (Excel)',
            READ_SURVEY:'Umfragen ansehen',
            MANAGE_SURVEY:'Umfragen bearbeiten',
            AI_CHAT:'KI-Chat',
            READ_GOAL:'Ziele ansehen',
            MANAGE_GOAL:'Ziele bearbeiten',
            MANAGE_OVERALL_SETTING:'Benachrichtigungen',
            WEBSITE_WIDGET:'Website-Widget',
            READ_STAFF:'Mitarbeiter ansehen',
            MANAGE_STAFF:'Mitarbeiterverwaltung',
            MANAGE_DEPT:'Abteilungsverwaltung',
        },
        // 角色名，键是角色代码 _STAFF_ 后面那段（德 / 意界面也用英文名）
        roleName:{
            ADMIN:'Admin',
            MANAGER:'Manager',
            GUEST_RELATIONS:'Guest Relations',
            VIEWER:'Viewer',
        },
        // 角色说明（后端 description 只有英文），键是角色代码 _STAFF_ 后面那段
        roleDesc:{
            ADMIN:'Voller Zugriff, einschließlich Mitarbeiter, Plattformverbindungen und Website-Widget.',
            MANAGER:'Alle Daten und betrieblichen Einstellungen. Kann keine Mitarbeiter oder Verbindungen verwalten.',
            GUEST_RELATIONS:'Bearbeitet Bewertungen, Fälle und Umfragen im Tagesgeschäft.',
            VIEWER:'Nur Ansicht. Kann Berichte herunterladen, aber keine Daten bearbeiten oder exportieren.',
        },
        // 权限分组（/staff/roles 的 groupName）的显示名
        groups:{
            Overview:'Übersicht',
            Reviews:'Bewertungen',
            Cases:'Fälle',
            Replies:'Antworteinstellungen',
            Competition:'Wettbewerb',
            Reports:'Berichte',
            Surveys:'Umfragen',
            Other:'Intelligence',
            Goals:'Ziele',
            Settings:'Einstellungen',
            Staff:'Mitarbeiter',
        },
    },
    Departments:{
        title:'Abteilungen',
        addDepartment:'Abteilung hinzufügen',
        editDepartment:'Abteilung bearbeiten',
        addSub:'Unterabteilung hinzufügen',
        edit:'Bearbeiten',
        delete:'Löschen',
        name:'Abteilungsname',
        namePlaceholder:'Abteilungsname eingeben',
        parent:'Übergeordnete Abteilung',
        topLevel:'Keine (oberste Ebene)',
        manager:'Leitung',
        managerPlaceholder:'Leitung auswählen',
        updatedBy:'Zuletzt geändert von',
        actions:'Aktionen',
        noDepartments:'Noch keine Abteilungen',
        cancel:'Abbrechen',
        confirm:'Bestätigen',
        save:'Speichern',
        confirmDeleteTitle:'Diese Abteilung löschen?',
        confirmDeleteBody:'Dies kann nicht rückgängig gemacht werden.',
        confirmDeleteBodyWithChildren:'Diese Abteilung hat Unterabteilungen. Das Löschen kann nicht rückgängig gemacht werden.',
        addSuccess:'Abteilung hinzugefügt',
        updateSuccess:'Abteilung aktualisiert',
        deleteSuccess:'Abteilung gelöscht',
        loadFailed:'Laden fehlgeschlagen. Bitte erneut versuchen.',
        saveFailed:'Vorgang fehlgeschlagen. Bitte erneut versuchen.',
        nameRequired:'Bitte Abteilungsnamen eingeben',
    },
    Settings:{
        title:'Einstellungen',
        left1:'Benutzer',
        left2:'Ziele',
        left3:'Benachrichtigungen',
        left4:'Widget',
        left5:'Verbindungen',
        left6:'Mitarbeiter',
        left7:'Abteilungen',
        left8:'Rollen und Berechtigungen',
        teamGroup:'Team',
        Widget:{
            title:'Bewertungs-Widget',
            desc:'Betten Sie Ihre WQI-Werte auf jeder Website ein. Ein Script-Tag genügt.',
            activeWidgets:'Aktive Widgets',
            createNew:'Neues Widget erstellen',
            style:'Stil',
            styleCompact:'Fußzeile / Abzeichen',
            styleHorizontal:'Hero-Streifen',
            styleCard:'Alle Kategorien',
            styleDark:'Dunkle Überlagerung',
            period:'Bewertungszeitraum',
            period3m:'Letzte 3 Monate',
            period12m:'Letzte 12 Monate',
            periodAll:'Gesamte Zeit',
            brandColor:'Markenfarbe',
            custom:'Benutzerdefinierte Farbe',
            domains:'Erlaubte Domains',
            domainsHint:'Leer lassen, um alle Domains zuzulassen.',
            domainsPlaceholder:'z.B. ihrhotel.de',
            generate:'Einbettungscode generieren',
            readyTitle:'Widget bereit',
            readyDesc:'Kopieren Sie den Code und fügen Sie ihn in den <body> Ihrer Website ein.',
            copy:'Code kopieren',
            copied:'Kopiert!',
            revoke:'Widerrufen',
            revokeConfirm:'Dieses Widget widerrufen? Kunden, die diesen Code verwenden, sehen das Widget nicht mehr.',
            revokeSuccess:'Widget widerrufen.',
            createError:'Erstellung fehlgeschlagen. Bitte erneut versuchen.',
            createdAt:'Erstellt',
            platformScores:'Plattformbewertungen (OTA)',
            platformScoresHint:'Plattformen auswählen, deren Einzelbewertungen im Widget angezeigt werden.',
            categories:'Kategorien',
            categoriesHint:'Kategorien auswählen. Leer lassen, um alle anzuzeigen.',
            livePreview:'Live-Vorschau',
            previewNote:'Beispielwerte – tatsächliche Werte basieren auf Ihren Hoteldaten',
            selectAll:'Alle auswählen',
            clearAll:'Zurücksetzen',
            noHotel:'Bitte zuerst ein Hotel auswählen.',
        },
        User:{
            label1:'Anmeldeinformationen',
            label2:'Passwort ändern',
            label3:'Aktuelles Passwort',
            label4:'Neues Passwort',
            label5:'Neues Passwort bestätigen',
            prompt1:'Passwortanforderungen:',
            prompt2:'stellen Sie sicher, dass es mindestens 8 Zeichen lang ist ',
            prompt3:'muss eine Zahl, einen Großbuchstaben und einen Kleinbuchstaben enthalten',
            button1:'Passwort ändern',
        },
        Goals:{
            title:'Ziele',
            label1:'Kategorie',
            label2:'Bewertung',
            label3:'Ziel',
            label4:'Differenz',
            label5:'Fälligkeitsdatum',
            label6:'Countdown',
            days:"Tage",
            unsaved:"Sie haben nicht gespeicherte Änderungen",
            cancel:"Abbrechen",
            notSet:"Nicht festgelegt",
            setGoal:"Ziel festlegen",
            clearGoal:"Entfernen",
            // 手机宽度紧凑表格：目标值单元格「设置」、编辑行的「保存」
            set:"Setzen",
            save:"Speichern",
            goalReference:"Richtwert: {value}",
        },
        Notifications:{
            title:'Benachrichtigungen',
            enableLabel:'E-Mail-Benachrichtigungen aktivieren',
            enableDesc:'Erhalten Sie E-Mail-Benachrichtigungen, wenn ausgewählte Bewertungsbedingungen ausgelöst werden.',
            otaAlertTitle:'OTA-Bewertungswarnungen',
            otaTitle:'OTA-Bewertungsschwellen',
            otaDesc:'Erhalten Sie eine Benachrichtigung, wenn eine neue Bewertung unter den für jede Plattform festgelegten Schwellenwert fällt.',
            wtkTitle:'WQI-Schwelle',
            wtkLabel:'WQI',
            categoryTitle:'Kategorie-Bewertungsschwellen',
            riskSignalTitle:'KI-Risikosignal-Benachrichtigungen',
            riskSignalDesc:'Erhalten Sie eine Benachrichtigung, wenn WTK verborgene Risikomuster erkennt, die aus der OTA-Bewertung allein nicht ersichtlich sind.',
            ratingDiscrepancy:'Score-Abweichung',
            ratingDiscrepancyDesc:'Benachrichtigung, wenn das im Bewertungstext beschriebene Gästeerlebnis nicht mit der vergebenen OTA-Bewertung übereinstimmt.',
            negativeOnly:'Ausschließlich negative Bewertung',
            negativeOnlyDesc:'Benachrichtigung, wenn eine Bewertung nur negative Stimmung ohne positives Feedback enthält.',
            recipientsTitle:'Benachrichtigungsempfänger',
            emailTitle:'Benachrichtigungs-E-Mail-Empfänger',
            emailPlaceholder:'E-Mail-Adresse eingeben',
            addEmail:'E-Mail hinzufügen',
            addBtn:'Hinzufügen',
            cancelBtn:'Abbrechen',
            saveBtn:'Einstellungen speichern',
            invalidEmail:'Bitte geben Sie eine gültige E-Mail-Adresse ein',
            emailExists:'Diese E-Mail wurde bereits hinzugefügt',
            reportRecipientsTitle:'Berichtsempfänger',
            reportEmailTitle:'Berichts-E-Mail-Empfänger',
            reportEmailDesc:'Wählen Sie aus, wer Ihre regelmäßigen Leistungsberichte erhält.',
            selectFromStaff:'Aus Mitarbeitern auswählen',
            noStaff:'Noch keine Mitarbeiter',
        },
    },
    Reports:{
        Performance:'Leistung',
        Score:'Bewertung',
        Reviews:'Bewertungen',
        Week1:'Woche 1',
        Week2:'Woche 2',
        Week3:'Woche 3',
        Week4:'Woche 4',
        Week5:'Woche 5',
        Week6:'Woche 6',
        Avg:' Avg.',
        Goal:'Ziel',
        Above_Goal:'Über Ziel',
        Below_Goal:'Unter Ziel',
        Week_High:'Hoch',
        Week_Low:'Tief',
        Week_One:'Woche {n}',
        Week_Many:'Wochen {n}',
        Month_Avg:'Ø {month}',
        Executive_Summary:'Zusammenfassung für die Geschäftsleitung',
        // 手机上长列表默认只显示两条，展开 / 收起；窄图表的横轴周次简写
        Show_All_N:'Alle anzeigen ({n})',
        Show_Less:'Weniger anzeigen',
        Week_Short:'W{n}',
        Insufficient_Data_Title:'Unzureichende Daten',
        Insufficient_Data_Reason:'Die Anzahl der Bewertungen liegt für diesen Zeitraum unter dem Analyseschwellenwert. Der Bericht wird automatisch erstellt, sobald der Schwellenwert erreicht ist.',
        competitors:{
            Executive_Competitive_Snapshot: 'Exekutive Wettbewerbsübersicht',
            Market: 'Markt',
            Competitive_Leverage: 'Wettbewerbsvorteil',
            Competitive_Pressure: 'Wettbewerbsdruck',
            What_Management_Must_Do: 'Was das Management tun muss',
            Relative_Positioning_Strengths_vs_Risks: 'Relative Positionierung: Stärken vs Risiken',
            Top_Competitive_Observations: 'Wichtigste Wettbewerbsbeobachtungen',
            Top_5_Positives: 'Top-Positives',
            Top_5_Negatives: 'Top-Negatives',
            Reason: 'Grund',
            Competitive_Dimensions: 'Wettbewerbsdimensionen',
            Share_Trigger_Landscape: 'Marktanteils-Trigger-Landschaft',
            Operational_Challenges: 'Betriebliche Herausforderungen',
            Competitor_Patterns: 'Wettbewerbermuster',
            Overview: 'Übersicht',
            Wins: 'Stärken',
            Learning_Value: 'Lernwert',
            Frictions: 'Reibungspunkte',
            Risk_Relevancy: 'Risikorelevanz',
            Top_Mentions: 'Top-Erwähnungen',
            Food_Mentions: 'Food-Erwähnungen',
            Beverage_Mentions: 'Getränke-Erwähnungen',
            Cross_Competitor_Analysis: 'Wettbewerbsübergreifende Analyse',
            Cross_Competitor_Patterns: 'Wettbewerbsübergreifende Muster',
            Category_Summary: 'Kategoriezusammenfassung',
            Case_study_of_the_month: 'Fallstudie: ',
            Case_study_of_the_month_tooltip: 'Der Wettbewerber, der in dieser Kategorie am meisten hervorsticht - entweder deutlich stärker oder schwächer als der Rest der Vergleichsgruppe.',
            Case_study: 'Fallstudie',
            Guest_Desire: 'Gastwunsch',
            Execution: 'Umsetzung',
            Takeaway: 'Kernpunkte',
            Best_practice: 'Beste Praxis',
            Staff_Shortages: 'Personalengpässe',
            Outdated_Systems: 'Veraltete Systeme',
            High_Guest_Expectations: 'Hohe Gästeerwartungen',
            Action_Focus: 'Aktionsfokus',
            Experience_Strengths:'Erfahre Stärken',
            Experience_Constraints:'Erfahrungsschranken',
            Guest_Attention_Triggers:'Gästenaufmerksamkeit auslösende Faktoren',
            Guest_Attention_Triggers_h2:'Diese Elemente beeinflussen das Gästewahrnehmung und die Weiterempfehlung disproportional',
            Guest_Attention_Triggers_empty:'Für diese Unterkunft wurden in diesem Zeitraum keine aufmerksamkeitsauslösenden Faktoren festgestellt.',
            Report_Generating:'Der Bericht dieses Hotels für diesen Zeitraum wird erstellt. Er erscheint hier automatisch.',
            Report_Stalled:'Die Erstellung dauert länger als üblich. Schauen Sie in ein paar Minuten wieder vorbei.',
            Report_Failed:'Der Bericht dieses Hotels konnte nicht geladen werden.',
            Restaurant_Detail:'Restaurant-Details',
        },
        MoM:{
            title:'Monatsvergleich (MoM)',
            lastMonth:'Letzter Monat',
            thisMonth:'Dieser Monat',
            monitorClosely:'Eng beobachten',
            badge_new:'Neu',
            badge_resolved:'Signal bereinigt',
            badge_recurring:'Wiederkehrend',
            month_apr:'Apr',
            month_mar:'Mär',
            tracking_mock_1:'Nachmittagstee: Gäste empfanden das Essen als durchwachsen; Premium-Bezug zur Preislage war weniger klar.',
            tracking_mock_2:'Begrüßung an der Rezeption zu Stoßzeiten beim Check-in uneinheitlich.',
            tracking_mock_3:'Außen- oder Halb-Außenplätze gelegentlich durch Lärm oder Zug betroffen — Stimmung verbesserte sich nach Hinweisschildern und Layout-Anpassungen.',
            tracking_mock_4:'Einzelmeldung zu verzögertem Abholservice für Vorbestellung — punktuell, kein Muster.',
            action_title:'Umsetzung nach Maßnahmen',
            col_current_signal:'Aktuelles Signal',
            col_last_action:'Maßnahme letzten Monats',
            effective:'Wirksam',
            low_confidence:'geringe Datenlage',
            confidence_medium:'mittlere Datenlage',
            confidence_high:'hohe Datenlage',
            empty_column:'Keine Einträge in dieser Periode.',
            empty_solution:'Keine Maßnahmenverfolgung.',
            action_signal_1:'Das Thema taucht in Gästefeedback nicht mehr auf.',
            action_last_1:'Einzelfall — Takeaway-Ablauf überprüft und Vorbereitungs-SLAs mit dem Team bestätigt.',
            action_signal_2:'Positive Erwähnungen stabil; keine neuen negativen Cluster in Textbewertungen.',
            action_last_2:'Briefing mit F&B zu Präsentation des Nachmittagstee und Taktung zwischen Gängen.',
            hotel_col_recurring:'Wiederkehrende Themen ({n})',
            hotel_col_declined:'Rückläufige Beschwerden ({n})',
            hotel_col_new:'Neue Schwerpunkte ({n})',
            hotel_rank_n:'Rang {n}',
            hotel_mock_breakfast:'Frühstück',
            hotel_mock_restaurant:'Restaurant',
            hotel_mock_checkin:'Check-in',
            hotel_mock_elevator:'Aufzug',
            hotel_mock_billing:'Abrechnung',
            hotel_mock_price_fit:'Erlebnis vs. Preis',
            hotel_recurring_b_apr:'Warme Speisen weiterhin uneinheitlich; Stoßzeiten-Warteschlange erwähnt.',
            hotel_recurring_b_mar:'Mehrere Hinweise auf verzögerte Buffet-Nachfüllung.',
            hotel_recurring_r_apr:'Abend-Service-Taktung erneut; Lärm nahe offener Küche.',
            hotel_recurring_r_mar:'Ähnliche Themen Reservierungsübergabe und Sitzplatz-Wartezeit.',
            hotel_declined_ci_mar:'Weniger Reibung nach Expressspur für Check-in.',
            hotel_declined_el_mar:'Seltene Wartezeit-Beschwerden nach Wartungsvertrag-Fix.',
            hotel_new_b_apr:'Neue Cluster zu Minibar und Stadtsteuer auf der Rechnung.',
            hotel_new_p_apr:'Gäste hinterfragen, ob Zimmerprodukt zur Preiskategorie passt.',
            hotel_solution_title:'Maßnahmenverfolgung',
            hotel_sol_th_category:'Kategorie',
            hotel_sol_th_action:'Maßnahme & Details',
            hotel_sol_th_outcome:'Ergebnis',
            hotel_not_resolved:'Nicht gelöst',
            still_observed:'Weiterhin beobachtet',
            failure_type_label:'Themen-Schlüssel',
            hotel_sol_parent_location:'Lage & Umgebung',
            hotel_sol_sub_accessibility:'Barrierefreiheit',
            hotel_sol_1_mar:'Wegweisung am Haupteingang aktualisiert; Türteam zu Begleitung geschult.',
            hotel_sol_1_apr:'Nachfass: weniger unklare Wege in Textfeedback; Airport-Transfer-Hinweise beobachten.',
            hotel_sol_parent_fb:'F & B',
            hotel_sol_sub_breakfast:'Frühstücksbetrieb',
            hotel_sol_2_apr:'Checkliste Nachfüllfenster; Runner in der Peak-Zeit 7–9 Uhr.',
            hotel_sol_parent_billing:'Abrechnung & Zahlung',
            hotel_sol_sub_invoice:'Rechnungsgenauigkeit',
            hotel_sol_3_apr:'Weiter vereinzelt doppelte Belastungen; Finanzen prüft PMS-Posting.',
        },
        Export_Pdf:'Pdf exportieren',
        Lang_Fallback:'Für dieses Hotel gibt es noch keinen Bericht auf {want}, daher wird er auf {shown} angezeigt.',
        Export_Pdf_Generating:'Der Bericht für diesen Zeitraum wird noch erstellt. Bitte versuchen Sie es in einigen Minuten erneut.',
        Export_Pdf_Unavailable:'Das PDF für diesen Zeitraum kann gerade nicht erstellt werden. Bitte versuchen Sie es später erneut.',
    },
    Brand_Overview:{
        title:'Markenübersicht',
        // Portfolio Insights（BrandOverview2）各竞品模块的空状态：接口没给竞品就只显示这一句，不补任何数字（WTK-753）
        noCompetitorData:'Noch keine Wettbewerberdaten',
        All_hotels:'Alle Hotel',
        Portfolio_Brand:'Portfolio / Marke',
        All_Brands:'Alle Marken',
        Selected_hotels:'Ausgewählte Hotel',
        Hotel_information:'Hotelinformationen',
        Country:'Land',
        Area:'Gebiet',
        Address:'Adresse',
        Stars:'Sterne',
        Number_of_rooms:'Anzahl der Zimmer',
        Status_Open:'Eröffnet',
        Status_Opening:'Demnächst',
        Ranking:{
            text1:'Durchschnitt Punktzahl',
            text2:'APAC Durchschnitt',
            text3:'EMEA (Europa) Durchschnitt',
            text4:'N. Amerika Durchschnitt',
            text5:' Gesamtwertung',
            text6:' Hotel Score',
            text7:'Globales Ranking',
            text8:'Regionales Ranking',
            average_score:'Durchschnitt',
        },
        Map_view:'Globaler Überblick',
        Competitor_score_of_OTA_platforms:'OTA Scores Übersicht',
        Total_reviews:'Gesamtzahl der Kommentare',
        Marriott_Member_Status_Performance:'Marriott Mitgliedsstatus Leistung',
        Room_nights:'Zimmer Nächte',
        Reviews:'Bewertungen',
        Review_Rate:'Bewertung Rate',
        Status:'Status',
        Avg_Score:'Durchschnittliche Punktzahl',
        Recommend:'Empfehlen',
        Ambassador:'Botschafter',
        Titanium:'Titan',
        Platinum:'Platin',
        Gold:'Gold',
        Silver:'Silber',
        Member:'Mitglied',
        Club:'Club-Mitglied',
        SilverElite:'Silber Elite',
        GoldElite:'Gold Elite',
        PlatinumElite:'Platin Elite',
        DiamondElite:'Diamant Elite',
        Customer_Journey:'Kundenreise',
        Date:'Datum',
        NovemberAvg:'Durchschnittswert im November',
        RegionalAvg:'Regionaler Durchschnitt',
        Global_Average:'Globaler Durchschnitt',
        Regional_Average:'Regionaler Durchschnitt',
        Brand_consistency:'Markenkonsistenz',
        Regional_City_Segmentation_Ranking_List:'Regionen/Städte',
        Rank:'Rang',
        Hotel:'Hotel',
        Total_score:'Gesamtpunktzahl',
        Brand_Consistency_Score:'Markenkonstanzindex',
        Global_Brand_Alignment_Ranking:'Globales Brand Alignment Ranking',
        Local_Cultural_Expression_Ranking:'Lokaler kultureller Ausdruck Ranking',
        Innovation_Ranking:'Innovationsranking',
        Elite_Recognition_Ranking:'Elite Anerkennung Ranking',
        Intention_to_Recommend_Ranking:'Absicht, Ranking zu empfehlen',
        CategoryLabel:[
            {
                name:"Standort",
                icon:icon_Location,
                value:"Location",
            },
            {
                name:"Sauberkeit",
                icon:icon_Cleanness,
                value:"Cleanness",
            },
            {
                name:"Zimmer",
                icon:icon_Room,
                value:"Room",
            },
            {
                name:"Ausstattung",
                icon:icon_Amenities,
                value:"Amenities",
            },
            {
                name:"F & B",
                icon:icon_FB,
                value:"F & B",
            },
            {
                name:"Dienstleistungen",
                icon:icon_Service,
                value:"Service",
            },
            {
                name:"Wert",
                icon:icon_Value,
                value:"Value",
            },
            {
                name:"Marke",
                icon:icon_Brand,
                value:"Brand",
            },
        ],
        Over_score:'Über Punktzahl',
    },
    likeTemplate:{
        total:'Gesamtzahl',
        dialogText:'Soll das Favoriten entfernt werden?',
        btn1:'Stornieren',
        btn2:'Bestätigen',
        Default_reply:'Standardantwort',
        ScoreTemplate:{
            h1:'Automatisch den entsprechenden Antworttext basierend auf der Bewertung (1-10 Punkte) auswählen',
            h1Restaurant:'Automatisch den entsprechenden Antworttext basierend auf der Bewertung (1-5 Punkte) auswählen',
            h2:'Jeder Notensatz kann individuell angepasst werden. Änderungen gelten nur für den ausgewählten Notensatz.',
            Default:'Standard',
            Edit:'Bearbeiten',
            Reset_to_default:'Zurücksetzen auf Standard',
            Cancel:'Stornieren',
            Save:'Speichern',
            Title:'Titel',
            Start:'Anfang',
            Main_Body:'Haupttext',
            Ending:'Schluss',
        },
        Collecting_Reviews:'Bewertungen sammeln',
    },
    Survey:{
        title:'Untersuchung',
        pageTitle:'Umfragezentrum',
        overview:'Überblick',
        duringStay:'Während des Aufenthalts',
        postStay:'Nach dem Aufenthalt',
        mainIssuesTop3:'Top 3 Hauptprobleme',
        sentimentSplit:'Stimmungsverteilung',
        aiInsightSummary:'KI-Erkenntnis-Zusammenfassung',
        topPositives:'Top Positive',
        topNegatives:'Top Negative',
        responses:'Antworten',
        avg:'Durchschn.',
        tickets:'Tickets',
        insights:'Erkenntnisse',
        recommend:'Empfehlen',
        needAttention:'benötigen Aufmerksamkeit',
        urgent:'dringend',
        goal:'Ziel',
        vsLastPeriod:'vs letzte Periode',
        urgentOnly:'Nur dringend',
        department:'Abteilung',
        addNotes:'+ Notizen hinzufügen',
        total:'Gesamt',
        selectStaff:'Mitarbeiter auswählen',
        searchStaff:'Mitarbeiter suchen..',
        noStaffFound:'Keine Mitarbeiter gefunden',
        resolve:'Lösen',
        showMore:'Mehr anzeigen',
        reviewDate:'Bewertungsdatum',
        assignedJustNow:'Gerade zugewiesen',
        resolvedJustNow:'Gerade gelöst',
        assign:'Zuweisen',
        reassign:'Neu zuweisen',
        positive:'Positiv',
        neutral:'Neutral',
        negative:'Negativ',
        tab_all:'Alle',
        tab_unresolved:'Ungelöst',
        tab_assigned:'Zugewiesen',
        tab_resolved:'Gelöst',
        badge_urgent:'Dringend',
        badge_inProgress:'In Bearbeitung',
        badge_pending:'Ausstehend',
        badge_done:'Erledigt',
        badge_notNeeded:'Nicht nötig',
        dept_all:'Alle',
        dept_housekeeping:'Hauswirtschaft',
        dept_fb:'F&B',
        dept_frontDesk:'Rezeption',
        dept_concierge:'Concierge',
        cat_room:'Zimmer',
        cat_service:'Service',
        cat_fb:'F&B',
        metric_locationNeighborhood:'Lage & Umgebung',
        metric_cleanliness:'Sauberkeit',
        metric_roomComfort:'Zimmerkomfort',
        metric_hotelAmenitiesAtmosphere:'Hotelausstattung & Atmosphäre',
        metric_foodBeverage:'Speisen & Getränke',
        metric_guestExperienceService:'Gästeerlebnis & Service',
        metric_valueForMoney:'Preis-Leistung',
        resolveOpt_done_title:'Erledigt',
        resolveOpt_done_sub:'Probleme gelöst',
        resolveOpt_notNeeded_title:'Nicht nötig',
        resolveOpt_notNeeded_sub:'Keine Aktion erforderlich',
        time_minsAgo:'vor {n} Min.',
        time_yesterday:'Gestern',
        time_daysAgo:'vor {n} Tagen',
        time_resolvedOn:'Gelöst am {date}',
        time_assignedNMinsAgo:'Zugewiesen vor {n} Min.',
        room:'Zimmer',
        guest:'Gast',
        visitor:'Besucher',
    },
    SurveyPostStay:{
        overallScore:'Hotel-Standalone-Score',
        hotelStandaloneScore:'Hotel-Standalone-Score',
        yourHotelOverall:'Gesamtscore Ihres Hotels',
        scoreRate:'Umfragebeteiligung',
        responseRatio:'Antwortquote',
        recommendRateTitle:'Weiterempfehlungsabsicht',
        completionRate:'Abschlussrate',
        completionStats:'{completed} abgeschlossen • {incomplete} unvollständig',
        managementResponseRate:'Management-Antwortrate',
        replyStats:'{replied} beantwortet • {pending} ausstehend',
        surveyQualityByCountries:'Survey Quality by Countries',
        surveyQualityByLanguage:'Survey Quality by Language',
        received:'Erhalten',
        unreceived:'Nicht erhalten',
        recommend:'Empfehlen',
        doNotRecommend:'Nicht empfehlen',
        scoreLe6:'Score ≤ 6',
        scoreEq7:'Score = 7',
        scoreEq8:'Score = 8',
        scoreGe9:'Score ≥ 9',
        mentions:'Erwähnungen',
        sampleSize:'n={n}',
        categoryShareTooltip:'Anteil aller Umfrageantworten mit Bewertung in dieser Kategorie.',
        top10Countries:'Top 10 Länder',
        top10Language:'Top 10 Sprachen',
        colRank:'Rang',
        colCountry:'Land',
        colLanguage:'Sprache',
        colScore:'Score',
        colRecommend:'Empfehlung',
        colNumber:'Anzahl',
        colReceived:'Erhalten',
        cat_checkIn:'Check-in-Erlebnis',
        cat_cleanliness:'Sauberkeit',
        cat_roomComfort:'Zimmerkomfort',
        cat_breakfast:'Frühstück',
        cat_diningBar:'Dining & Bar',
        cat_facilities:'Ausstattung & Annehmlichkeiten',
        cat_staffService:'Personal & Service',
        cat_checkOut:'Check-out-Erlebnis',
        reviewsBySubcategory:'Bewertungen nach Unterkategorie',
        colSubcategory:'Unterkategorie',
        colRatingCount:'Count',
        colReviewCount:'Anzahl Kommentare',
        colScoreShare:'Score-Verteilung',
        filterExcellent:'Excellent',
        filterGood:'Good',
        filterAverage:'Average',
        filterBad:'Bad',
        noSubcategoryData:'Keine Unterkategoriedaten',
        reviewDate:'Bewertungsdatum',
        showMore:'Mehr anzeigen',
        showLess:'Weniger anzeigen',
        noCommentReviews:'Keine Kommentare',
        metaRoomType:'Zimmertyp',
        metaCheckIn:'Check-in',
        metaCheckOut:'Check-out',
        metaMembership:'Mitgliedsstufe',
    },
    SurveyDetail:{
        pageTitle:'Antworten',
        crumb:'Post-Stay-Umfrage · Einzelne Rohantworten (Quelldaten hinter aggregierten Insights)',
        time24h:'Letzte 24 Std.',
        timeWeek:'Diese Woche',
        timeMonth:'Dieser Monat',
        filterScoreAll:'Alle Bewertungen',
        filterScoreLow:'≤6 Negativ',
        filterScoreMid:'7 Neutral',
        filterScoreHigh:'≥8 Positiv',
        filterStatusAll:'Alle Status',
        filterStatusNew:'Ausstehend',
        filterStatusDone:'Gelesen',
        filterTextAll:'Textfilter',
        filterTextYes:'Mit Text',
        filterTextNo:'Nur Bewertung',
        responseCount:'{n} Antworten',
        colSubmitted:'Eingereicht',
        colGuest:'Gast',
        colChannel:'Kanal',
        colRoom:'Zimmertyp',
        colNights:'Nächte',
        colScore:'Bewertung',
        colRecommend:'Empfehlung',
        colCheckIn:'Check-in',
        colCheckOut:'Check-out',
        colMemberLevel:'Mitgliedsstufe',
        colReplyStatus:'Antwortstatus',
        colText:'Text',
        colStatus:'Status',
        recommendYes:'Ja',
        recommendNo:'Nein',
        replyUnreplied:'Antworten',
        replyReplied:'Beantwortet',
        textSegments:'{n} Abschnitte',
        statusNew:'Ausstehend',
        statusDone:'Gelesen',
        listHint:'Klicken Sie auf eine Zeile für die vollständige Antwort',
        backToList:'Zurück zur Antwortliste',
        part1Title:'Part 1 · Overall satisfaction',
        part2Title:'Part 2 · Vom Gast gewählte Schwerpunkt-Dimensionen · Dimensionsbewertung + Unterpunkte (strukturierte Bewertung)',
        part3Title:'Part 3 · Weitere gewählte Dimensionen · Dimensionsbewertung + Unterpunkte (strukturierte Bewertung)',
        overallScoreLabel:'Overall Score',
        solvedLabel:'Solved',
        dimEvaluation:'Dimensionsbewertung',
        notesToManager:'Notes to manager',
        summaryTitle:'Summary',
        prevResponse:'Zurück',
        nextResponse:'Weiter',
        metaCountry:'Country',
        q1Label:'Q1 · Gesamtzufriedenheit',
        q2Label:'Q2 · Vom Gast gewählte Schwerpunkte',
        q3Label:'Q3 · Dimensionsbewertungen + Unterpunkte',
        q4Label:'Freitext + KI-Extraktion',
        noAspects:'(keine Auswahl)',
        aiExtraction:'KI-Extraktionsergebnisse',
        sentimentNeg:'Neg',
        sentimentPos:'Pos',
        noFailureType:'(positiv · kein failure_type)',
        confidence:'Konfidenz {n}%',
        noFreeText:'Kein Freitext in dieser Antwort.',
        submittedAt:'Eingereicht {ts}',
        metaChannel:'Kanal',
        metaRoom:'Zimmertyp',
        metaNights:'Nächte',
        nightsUnit:'{n} Nächte',
        metaScore:'Gesamtbewertung',
        metaRecommend:'Empfehlung',
        metaExtractions:'Textextraktionen',
        yes:'Ja',
        no:'Nein',
        issueResolvedTitle:'Problem gelöst?',
        issueResolvedYes:'Gast meldet gelöst',
        issueResolvedNo:'Gast meldet nicht gelöst',
        guestPerceived:'gastwahrgenommen · nicht faktisch',
        gmNoteTitle:'Notiz an GM',
        markRead:'Als gelesen markieren',
        assignFollowUp:'Follow-up zuweisen',
        waitingForReply:'Warten auf Antwort',
        aiReplyTitle:'KI-Antwort',
        aiLangPlaceholder:'Sprache wählen',
        aiTranslation:'Übersetzung',
        aiGenerate:'Generieren',
        aiEdit:'Bearbeiten',
        aiSend:'Senden',
        specificReply:'Spezifische Antwort',
        detailHint:'Gelbe Markierungen = KI-identifizierte Fragmente; rechts failure_type + Dimension + Konfidenz.',
    },
    NeedsAttention:{
        Search_reviews_or_notes: 'Bewertungen oder Notizen suchen',
        Review_Date: 'Datum',
        Status: 'Status',
        Priority: 'Prioritat',
        Attention: 'Hinweis',
        More_filters: 'Mehr Filter',
        filters: 'Filter',
        OTA_Source: 'OTA-Quelle',
        Source: 'Quelle',
        Affected_Areas: 'Betroffene Bereiche',
        Days_since_posted: 'Tg. seit Veröff.',
        Days: 'Tg. seit Veröff.',
        OTA_Score: 'Bewertung',
        days: 'Tage',
        Reset: 'Zurücksetzen',
        Apply: 'Anwenden',
        WTK_Score: 'WQI',
        Attention_Reason: 'Hinweis',
        'Under Review':'In Pruifung',
        Under_Review: 'In Pruifung',
        Open: 'Offen',
        Closed: 'Geschlossen',
        Actioned: 'Bearbeitet',
        All:'All',
        show_All:'Alle anzeigen',
        High: 'Hoch',
        Medium: 'Mittel',
        Low: 'Niedrig',
        AutoAlert: 'Auto-Alarm',
        Extremely_Negative: 'Extrem Negativ',
        Rating_Discrepancy: 'Score-Abweichung',
        Negative_Only: 'Nur Negativ',
        'Extremely Negative':'Extrem Negativ',
        'Rating Discrepancy':'Score-Abweichung',
        'Negative Only':'Nur Negativ',
        Extremely_Negative_Tip:'OTA-Bewertung unter 7/10 (oder 3,5/5)',
        Rating_Discrepancy_Tip:'OTA- und Stimmungswerte weichen um 2+ Punkte ab',
        Negative_Only_Tip:'Nur negatives Feedback, keine positiven Kommentare',
        Total: 'Gesamt',
        Key_Metrics: 'Kernkennzahlen',
        Guest_Rating: 'Gästebewertung',
        Days_Since: 'Tage seit Post',
        Guest_Review: 'Bewertung',
        Summary: 'Zusammenfassung',
        Negative_Summary: 'Zusammenfassung',
        Management_Note: 'Notiz',
        Edit: 'Bearbeiten',
        Action: 'Maßnahme',
        Save: 'Speichern',
        Show_more: 'Mehr anzeigen',
        Show_Less:'Weniger anzeigen',
        startTime:'Start',
        endTime:'End',
        Last_updated_date:'Datum der letzten Aktualisierung',
        History:'Verlauf',
        History_empty:'Noch keine Änderungen.',
        History_load_failed:'Verlauf konnte nicht geladen werden.',
        History_retry:'Erneut versuchen',
        History_created:'Zum Fallmanagement hinzugefügt',
        History_note_cleared:'(gelöscht)',
        History_remark:'Anmerkung',
        No_reviews1:'Keine aktiven Aufmerksamkeitspunkte',
        No_reviews2:'Neue Bewertungen mit Hinweisen auf erforderliche Maßnahmen werden hier erscheinen.',
        dialogTitle:'Entfernen Sie dieses Element aus der Liste',
        dialogText:'Dies wird das Element und seine Notizen dauerhaft löschen.',
        Cancel:'Stornieren',
        Delete:'Löschen',
        drawerMessage:'Notiz darf nicht leer sein',
        Reply_column:'Antwort',
        Reply_status:'Antwortstatus',
        Replied:'Beantwortet',
        Not_replied:'Nicht beantwortet',
        Reply_title:'Antwort',
        Reply_date:'Antwortdatum',
        Replied_by:'Beantwortet von',
        No_reply_yet:'Noch keine Antwort',
        Reply_load_failed:'Die Antwort konnte nicht geladen werden.',
        // 手机卡片列表 / 筛选（≤767px）
        Actions:'Weitere Aktionen',
        View_details:'Details anzeigen',
        No_priority:'Keine Priorität',
        Remove_filter:'Filter entfernen',
        Reset_all:'Alle zurücksetzen',
        Posted_days:'Heute veröffentlicht | Vor 1 Tag veröffentlicht | Vor {n} Tagen veröffentlicht',
        Load_failed1:'Fälle konnten nicht geladen werden',
        Load_failed2:'Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
        No_results1:'Keine passenden Fälle',
        No_results2:'Ändern Sie den Zeitraum, die Suche oder die Filter.',
    },
    ReplyLibrary:{
        Search_reviews_or_replies:'Bewertungen oder Antworten suchen…',
        Affected_Areas:'Betroffene Bereiche',
        OTA_Source: 'OTA-Quelle',
        Sort: 'Sortieren',
        Sort_by:'Sortieren nach',
        Time_newest_first:'Zeit (neueste zuerst)',
        Time_oldest_first:'Zeit (älteste zuerst)',
        Score: 'Bewertung',
        OTA_Score1:'OTA-Quelle (höchste zuerst)',
        OTA_Score2:'OTA-Quelle (niedrigste zuerst)',
        Saved_Reason:'Gespeicherter Grund',
        Use_case:'Anwendungsfall',
        tags:'Tags',
        Cancel:'Stornieren',
        Save:'Speichern',
        Discard :'Verwerfen',
        Discard_changes :'Änderungen verwerfen',
        No_reason_recorded  :'Kein Grund vermerkt',
        No_use_cases_assigned  :'Keine Zuweisung von Use Cases',
        You_editing_another_reply:'Du bearbeitest eine andere Antwort',
        you_tooltip:'Bitte speichere deine Änderungen vor dem Wechsel oder verwerfe sie und fahre fort.',
        unLike:'Aus Favoriten entfernen',
        No_saved1:'Noch keine gespeicherten Antworten',
        No_saved2:'Speichern Sie häufig genutzte Antworten, um eine strukturierte Antwortbibliothek aufzubauen.',
        // 手机底部弹层（预设原因 / 使用场景）
        Saved_reason_hint:'Warum diese Antwort gespeichert wird – so finden und nutzen Sie sie später leichter.',
        Use_case_hint:'Anwendungsfall eingeben und mit Enter hinzufügen. Mehrere sind möglich.',
        Unsaved_changes:'Es gibt ungespeicherte Änderungen. Verwerfen?',
        Keep_editing:'Weiter bearbeiten',
        Saving:'Wird gespeichert…',
        Save_failed:'Speichern fehlgeschlagen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
        Close:'Schließen',
    },
    FAQ:{
        needHelp:'Noch Fragen?',
        contactUs:'Kontakt',
        searchPlaceholder:'Fragen durchsuchen…',
        noMatches:'Keine passenden Fragen',
    },
    Connections:{
        title:'Verbindungen',
        intro:'Verbinden Sie Ihr eigenes Google-Unternehmensprofil und Ihren Tripadvisor-Eintrag mit WhereToKnow.',
        googleDesc:'Melden Sie sich mit dem Google-Konto an, dem das Unternehmensprofil dieses Betriebs gehört oder das es verwaltet, und wählen Sie dann den Standort.',
        tripadvisorDesc:'Suchen Sie den Tripadvisor-Eintrag dieses Betriebs oder fügen Sie den Link der Tripadvisor-Seite ein.',
        connected:'Verbunden',
        notConnected:'Nicht verbunden',
        needsReconnect:'Neu verbinden',
        chooseLocationStatus:'Standort wählen',
        unavailable:'Noch nicht verfügbar',
        connectGoogle:'Google verbinden',
        reconnect:'Neu verbinden',
        chooseLocation:'Standort wählen',
        changeLocation:'Standort ändern',
        connectTripadvisor:'Tripadvisor verbinden',
        changeListing:'Eintrag ändern',
        disconnect:'Trennen',
        viewListing:'Eintrag ansehen',
        signedInAs:'Angemeldet als {email}',
        chooseGoogleLocation:'Google-Standort wählen',
        chooseGoogleLocationHint:'Das sind die Unternehmensprofil-Standorte, die Ihr Google-Konto verwaltet.',
        noGoogleLocations:'Dieses Google-Konto verwaltet keinen Standort. Verbinden Sie sich mit dem Konto, dem der Standort gehört oder das ihn verwaltet.',
        searchTripadvisor:'Tripadvisor durchsuchen',
        searchPlaceholder:'Name des Betriebs',
        search:'Suchen',
        noResults:'Kein Eintrag gefunden. Versuchen Sie einen anderen Namen oder fügen Sie unten den Link ein.',
        orPasteLink:'Oder fügen Sie den Link Ihrer Tripadvisor-Seite ein',
        connect:'Verbinden',
        cancel:'Abbrechen',
        save:'Speichern',
        disconnectTitle:'{platform} trennen?',
        disconnectBody:'WhereToKnow verwendet diese Verbindung dann nicht mehr. Sie können sich jederzeit neu verbinden.',
        connectedToast:'{platform} verbunden',
        failed:'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
        notEnabled:'Verbindungen sind für diesen Betrieb noch nicht freigeschaltet. Kontaktieren Sie uns.',
        notForBrand:'Wählen Sie ein Hotel oder Restaurant, um seine Verbindungen zu verwalten.',
        finishingGoogle:'Google-Verbindung wird abgeschlossen…',
        backToConnections:'Zurück zu Verbindungen',
        connectAgain:'Google erneut verbinden',
        tripadvisorFromProfile: "Dies ist die Tripadvisor-Seite, von der wir die Bewertungen dieses Betriebs erfassen. Hier können Sie einen anderen Eintrag wählen; WhereToKnow prüft ihn vor dem Wechsel.",
        tripadvisorChangePending: "Wechsel zu {name} beantragt. WhereToKnow prüft ihn vor dem Wechsel; bis dahin bleibt der obige Eintrag in Verwendung.",
        disconnectBodyTripadvisor: "Nur die Verbindung wird entfernt: WhereToKnow erfasst die Tripadvisor-Bewertungen dieses Betriebs weiterhin. Sie können sich jederzeit wieder verbinden.",
        tripadvisorPendingNote:'Eingereicht. WhereToKnow prüft den Eintrag und bestätigt ihn.',
        pendingStatus:'Wartet auf Bestätigung',
        noMatchingGoogleLocation:'Keiner dieser Unternehmensprofil-Standorte ist {name} bei Google. Melden Sie sich mit dem Google-Konto an, das {name} verwaltet, oder kontaktieren Sie uns, wenn er hier aufgeführt ist.',
        useAnotherGoogleAccount:'Anderes Google-Konto verwenden',
        thisProperty:'Diese Unterkunft',
        promptTitle:'Verbinden Sie Ihr Google-Unternehmensprofil',
        promptBody:'Verknüpfen Sie das Unternehmensprofil dieser Unterkunft, damit WhereToKnow direkt mit Ihren Google-Bewertungen arbeiten kann.',
        promptAction:'Verbinden',
        promptDismiss:'Schließen',
        googleCancelled:'Die Google-Anmeldung wurde abgebrochen.',
        googleFailed:'Google konnte nicht verbunden werden. Bitte versuchen Sie es erneut.',
        startAgain:'Diese Google-Anmeldung konnte keinem Betrieb zugeordnet werden. Bitte starten Sie die Verbindung erneut.',
    },
    // 读屏用的 aria-label
    A11y:{
        close:'Schließen',
        openMenu:'Menü öffnen',
        scrollLeft:'Nach links scrollen',
        scrollRight:'Nach rechts scrollen',
        togglePanel:'Bereich ein-/ausklappen',
    },
    // 右下角帮助聊天气泡（components/common/SupportChatbot.vue）。msg 里的 \n 会被渲染成换行
    SupportChatbot:{
        brandStatus:'Support',
        title:'Wie können wir helfen?',
        subtitle:'Wählen Sie ein Thema oder geben Sie unten Ihre Frage ein.',
        placeholder:'Ihre Frage eingeben...',
        privacyPrefix:'Mit dem Chat stimmen Sie unserer',
        privacyLink:'Datenschutzerklärung',
        privacySuffix:' zu',
        contactTitle:'Support kontaktieren',
        contactBody:'Senden Sie uns eine ausführliche Nachricht — wir melden uns innerhalb von 1 Werktag.',
        noMatch:'Das konnte ich leider nicht zuordnen. Hier sind die wichtigsten Optionen:',
        opt:{
            learnFeature:'Mehr über eine Funktion erfahren',
            contactSupport:'Support-Team kontaktieren',
            reportIssue:'Problem melden',
            wqi:'WQI',
            hotelOverview:'Hotelübersicht',
            hotelCompetitors:'Hotel-Wettbewerber',
            restaurantOverview:'Restaurantübersicht',
            restaurantCompetitors:'Restaurant-Wettbewerber',
            replySetting:'Antworteinstellung',
            replyLibrary:'Antwortbibliothek',
            needsAttention:'Handlungsbedarf',
            reports:'Berichte',
            brandOverview:'Markenübersicht',
            staffLeaderboard:'Rangliste der Mitarbeiter-Erwähnungen',
            settings:'Einstellungen, Ziele & Benachrichtigungen',
            backToMain:'Zurück zum Hauptmenü',
            gotIt:'Verstanden',
            needMoreHelp:'Ich brauche weitere Hilfe',
            back:'Zurück',
            adjustCompSet:'Ich möchte mein Wettbewerbsset anpassen',
            dataMissing:'Daten laden nicht oder fehlen',
            crashError:'Absturz, Fehler oder Anzeigeproblem',
            resolvedIt:'Das hat geholfen',
            stillMissing:'Fehlt immer noch — Support per E-Mail',
            emailSupport:'Support-Team per E-Mail kontaktieren',
            anotherQuestion:'Ja, noch eine Frage',
            thatsAll:'Nein, das war’s',
            helpful:'Ja, das war hilfreich',
            notReally:'Nicht wirklich',
        },
        msg:{
            start:'Wobei kann ich Ihnen heute helfen?',
            featureHelp:'Über welchen Bereich möchten Sie mehr erfahren?',
            reportBug:'Entschuldigen Sie die Unannehmlichkeiten. Welche Art von Problem haben Sie?',
            bugData:'Bei fehlenden oder veralteten Daten versuchen Sie bitte:\n\n1. Prüfen Sie den Zeitstempel „Zuletzt aktualisiert“ — die Daten werden alle 2–4 Stunden aktualisiert\n2. Wählen Sie einen anderen Zeitraum\n3. Laden Sie die Seite vollständig neu (Strg+Umschalt+R / Cmd+Shift+R)\n\nFehlen die Daten nach 4 Stunden immer noch, kann unser Team das prüfen.',
            bugOther:'Damit wir das Problem lösen können, schreiben Sie uns bitte eine E-Mail mit:\n\n• Welche Seite oder welcher Bereich\n• Was Sie unmittelbar vor dem Problem getan haben\n• Was Sie erwartet haben und was passiert ist\n• Wenn möglich, einem Screenshot',
            connectHuman:'Unser Support-Team hilft Ihnen gerne. Wir antworten in der Regel innerhalb von 1 Werktag.',
            resolved:'Schön, dass es geholfen hat. Kann ich sonst noch etwas für Sie tun?',
            feedback:'Bevor Sie gehen — war dieses Gespräch hilfreich?',
            feedbackPositive:'Vielen Dank für Ihr Feedback. Einen schönen Tag noch.',
            feedbackNegative:'Danke für Ihre Offenheit. Sie können unser Support-Team direkt erreichen — es hilft Ihnen gerne:',
            library:'Die Antwortbibliothek ist Ihre persönliche Sammlung gespeicherter Antworten auf Bewertungen.\n\n• Klicken Sie bei einer Antwort auf das Herz-Symbol, um sie zu speichern\n• Jede gespeicherte Antwort enthält die Originalbewertung, Ihre Antwort, die OTA-Quelle, Scores und betroffene Bereiche\n• Mit den Tags „Speichergrund“ und „Anwendungsfall“ ordnen Sie Ihre Sammlung\n• Gespeicherte Antworten, Gründe und Tags können Sie jederzeit bearbeiten\n• Nach Datum, OTA-Quelle oder betroffenen Bereichen filtern oder nach Stichwort suchen',
            reports:'Berichte:\n\n• Verfügbare Zeiträume: wöchentlich, monatlich, quartalsweise, halbjährlich und jährlich\n• Jeder Bericht umfasst Kategorie-Scores, Trendübersicht, Management-Schwerpunkte und abteilungsfertige Maßnahmenpläne\n• Wochenberichte werden jeden Montag aktualisiert, Monatsberichte am 1. jedes Monats\n• Datenzuverlässigkeit: Grün = 50+ Bewertungen (hohe Aussagekraft), Gelb = 10–50, Rot = unter 10\n• Mit den Schaltflächen „Vorheriger Zeitraum“ / „Nächster Zeitraum“ Zeiträume vergleichen',
            hotel:{
                wqi:'Der WQI ist eine KI-generierte Bewertung (1–10), basierend auf der tatsächlichen Gästestimmung auf all Ihren Bewertungsplattformen.\n\nAnders als einfache Durchschnittswerte analysiert er den vollständigen Text und die emotionale Stärke jeder Bewertung in 7 Kategorien: Service, Sauberkeit, Zimmer, F&B, Ausstattung, Lage und Preis-Leistung.\n\nScore-Bereiche:\n• 9–10: Herausragend\n• 8–9: Sehr gut\n• 7–8: Gut\n• 6–7: Verbesserungsbedarf\n• Unter 6: Dringender Handlungsbedarf',
                dashboard:'Hotelübersicht auf einen Blick:\n\n• Die Daten werden automatisch alle 2–4 Stunden aktualisiert\n• Mit den Plattform-Tabs (Booking.com, Google, Expedia…) nach Quelle filtern\n• Auf einen KPI-Kreis klicken, um Unterkategorien und einzelne Bewertungen zu sehen\n• Die Rangliste der Mitarbeiter-Erwähnungen zeigt, welche Teammitglieder Gäste erwähnen und ob positiv oder negativ\n• Die F&B-Rangliste erfasst Highlights zu Speisen und Getränken aus den Bewertungen',
                competitors:'Hotel-Wettbewerber:\n\n• Ihr anfängliches Wettbewerbsset wird von WTK anhand von Lage, Kategorie, Preisspanne und Gästeüberschneidung erstellt\n• Änderungen am Wettbewerbsset können Sie jederzeit anfragen — die Aktualisierung dauert 24–48 Stunden\n• Standard: 5 Wettbewerber · Professional: bis zu 10 · Enterprise: individuell\n• Alle Wettbewerberdaten stammen ausschließlich von öffentlichen OTA- und Bewertungsplattformen',
                reply:'Antworteinstellung:\n\n• Wählen Sie eine Marken-Vorlage (Formell elegant, Premium herzlich, Locker verspielt, Minimal neutral), um Ihren Tonfall festzulegen\n• Passen Sie Förmlichkeit, Kurzformen, Emojis und Humor an Ihre Marke an\n• Sprache auf Automatisch (Antwort in der Sprache des Gastes) oder Fest stellen\n• Mit Smart Replies werden eigene Sätze automatisch eingefügt, wenn bestimmte Themen erwähnt werden\n• Antwortlänge festlegen: Kurz (30–60 Wörter) für OTAs, Standard, Ausführlich oder Dynamisch',
                attention:'Handlungsbedarf markiert mithilfe von KI-Risikosignalen automatisch Bewertungen, die sofortiges Handeln erfordern.\n\nJede markierte Bewertung trägt ein „Auto-Alarm“-Tag und bis zu zwei Risikosignal-Tags:\n• Abweichung Bewertung–Erlebnis — Lücke zwischen OTA-Score und WTK-Analyse\n• Extrem negativ — stark negative Stimmung über mehrere Kategorien\n• Nur negativ — keinerlei positive Aspekte\n\nFür jede Bewertung können Sie die Priorität (Hoch / Mittel / Niedrig) setzen, den Status aktualisieren (Offen → Bearbeitet → Geschlossen) und Management-Notizen hinzufügen. Die Tage seit Veröffentlichung sind farblich markiert: grün (≤3), orange (3–5), rot (>5).',
                brand:'Die Markenübersicht liefert hausübergreifende Einblicke für Ihre Hotelgruppe.\n\n• Globale & regionale Rankings — sehen Sie, wie jedes Hotel innerhalb der Marke abschneidet\n• Leistung nach Mitgliedsstatus — wie verschiedene Treuestufen ihren Aufenthalt bewerten\n• Markenkonsistenz & -ausdruck — verfolgt Ausrichtung, lokalen kulturellen Ausdruck, Innovation und Weiterempfehlungsabsicht\n• Nutzen Sie die Kartenansicht und die Regionsauswahl, um die Häuser zu erkunden',
                settings:'Einstellungen, Ziele & Benachrichtigungen:\n\n• Legen Sie Zielwerte für jede der 7 KPI-Kategorien fest — das Dashboard zeigt Differenz = Ist – Ziel in Echtzeit\n• Ziele sind jederzeit anpassbar und gelten pro Haus\n• Benachrichtigungen: E-Mail-Alarme für OTA-Score-Alarme (Schwellenwerte je Plattform) und KI-Risikosignal-Alarme (Abweichung Bewertung–Erlebnis, Nur negativ) aktivieren\n• Trip.com hat standardmäßig eine Höchstpunktzahl von 10, im chinesischen Sprachmodus 5\n• Mehrere E-Mail-Empfänger fügen Sie im Bereich Benachrichtigungsempfänger hinzu\n• Die Login-E-Mail kann nicht in den Einstellungen geändert werden — wenden Sie sich an Ihren Administrator oder unser Support-Team',
            },
            restaurant:{
                wqi:'Der WQI ist eine KI-generierte Bewertung (1–10), basierend auf der tatsächlichen Gästestimmung auf all Ihren Bewertungsplattformen.\n\nAnders als einfache Durchschnittswerte analysiert er den vollständigen Text und die emotionale Stärke jeder Bewertung in 7 Kategorien: Speisenqualität, Service, Ambiente, Sauberkeit, Preis-Leistung, Umgang mit Allergenen und Gesamterlebnis.\n\nScore-Bereiche:\n• 9–10: Herausragend\n• 8–9: Sehr gut\n• 7–8: Gut\n• 6–7: Verbesserungsbedarf\n• Unter 6: Dringender Handlungsbedarf',
                dashboard:'Restaurantübersicht auf einen Blick:\n\n• Die Daten werden automatisch alle 2–4 Stunden aktualisiert\n• Mit den Plattform-Tabs (Booking.com, Google, TripAdvisor…) nach Quelle filtern\n• Auf einen KPI-Kreis klicken, um Unterkategorien und einzelne Bewertungen zu sehen\n• Die Rangliste der Mitarbeiter-Erwähnungen zeigt, welche Teammitglieder Gäste erwähnen und ob positiv oder negativ\n• Verfolgen Sie Speisen-Highlights, Sonderwünsche und Ernährungsvorlieben aus dem Gästefeedback',
                competitors:'Restaurant-Wettbewerber:\n\n• Ihr anfängliches Wettbewerbsset wird von WTK anhand von Küchenart, Lage, Preisspanne und Gästeüberschneidung erstellt\n• Änderungen am Wettbewerbsset können Sie jederzeit anfragen — die Aktualisierung dauert 24–48 Stunden\n• Alle Wettbewerberdaten stammen ausschließlich von öffentlichen OTA- und Bewertungsplattformen',
                reply:'Antworteinstellung:\n\n• Wählen Sie eine Marken-Vorlage, um Ihren Tonfall festzulegen (Professionell, Herzlich, Locker, Minimal)\n• Passen Sie Förmlichkeit, Kurzformen, Emojis und Humor an Ihre Marke an\n• Sprache auf Automatisch (Antwort in der Sprache des Gastes) oder Fest stellen\n• Mit Smart Replies werden eigene Antworten automatisch eingefügt, wenn Küche, Allergene oder Service erwähnt werden\n• Antwortlänge festlegen: Kurz (30–60 Wörter), Standard, Ausführlich oder Dynamisch',
                attention:'Handlungsbedarf markiert mithilfe von KI-Risikosignalen automatisch Bewertungen, die sofortiges Handeln erfordern.\n\nJede markierte Bewertung trägt ein „Auto-Alarm“-Tag und bis zu zwei Risikosignal-Tags:\n• Score-Abweichung — Lücke zwischen OTA-Score und WTK-Analyse\n• Extrem negativ — stark negative Stimmung über mehrere Kategorien\n• Nur negativ — keinerlei positive Aspekte\n\nFür jede Bewertung können Sie die Priorität (Hoch / Mittel / Niedrig) setzen, den Status aktualisieren und Management-Notizen hinzufügen.',
                staff:'Rangliste der Mitarbeiter-Erwähnungen:\n\n• Erfasst automatisch Teammitglieder, die in Gästebewertungen erwähnt werden\n• Zeigt Anzahl der Erwähnungen, Stimmung (positiv / negativ) und wichtigstes Feedback\n• Hilft, Top-Performer zu erkennen und exzellenten Service zu würdigen\n• Zeigt, welche Mitarbeitenden den größten Einfluss auf die Gästezufriedenheit haben\n• Nach Zeitraum und OTA-Quelle filtern',
                settings:'Einstellungen, Ziele & Benachrichtigungen:\n\n• Legen Sie Zielwerte für jede der 7 KPI-Kategorien fest — das Dashboard zeigt Differenz = Ist – Ziel in Echtzeit\n• Ziele sind jederzeit anpassbar und gelten pro Restaurant\n• Benachrichtigungen: E-Mail-Alarme für OTA-Score-Alarme und KI-Risikosignal-Alarme aktivieren\n• Mehrere E-Mail-Empfänger fügen Sie im Bereich Benachrichtigungsempfänger hinzu\n• Die Login-E-Mail kann nicht in den Einstellungen geändert werden — wenden Sie sich an Ihren Administrator oder unser Support-Team',
            },
        },
    },
}
